import type { Dictionary } from "@/lib/i18n/dictionaries/en";

const ru: Dictionary = {
  // ---- /citation-styles/alphabetical/<letter> ----
  styleDirectory: {
    notFoundTitle: "Каталог стилей цитирования не найден",
    metaTitle: "Стили цитирования, начинающиеся с {label}",
    metaDescription:
      "Просмотрите {count} стилей Citation Style Language, начинающихся с {label}. Откройте любой стиль, чтобы увидеть реальные примеры цитирования и бесплатный генератор.",
    ogSubtitle: "{count} стилей с собственными примерами и генераторами.",
    ogKind: "Каталог A–Z",
    schemaName: "Стили цитирования, начинающиеся с {label}",
    schemaDescription:
      "Алфавитный каталог {count} стилей Citation Style Language, начинающихся с {label}.",
    breadcrumbStyles: "Стили цитирования",
    heading: "Стили цитирования, начинающиеся с {label}",
    intro:
      "Просмотрите все {count} стилей в этой части каталога CSL. На каждой странице есть отформатированные примеры самого стиля и бесплатный генератор цитат.",
    navLabel: "Стили цитирования от A до Z",
    listHeading: "Все стили, начинающиеся с {label}",
  },
  nav: {
    tools: "Инструменты",
    guides: "Руководства",
    styles: "Все стили",
    bibliography: "Моя библиография",
    search: "Поиск",
    glossary: "Глоссарий",
    home: "Главная",
    menu: "Меню",
  },

  home: {
    title: "Бесплатный генератор ссылок",
    subtitle: "Обновлено на 2026 год",
    intro:
      "Вставьте DOI, ссылку или запись BibTeX — либо найдите книгу — и получите корректно оформленное библиографическое описание в стилях APA, MLA, Chicago, Vancouver, Harvard и тысячах других. Полностью бесплатно, без платной подписки и без регистрации.",
    browseAllStyles: "Посмотреть все {count} стилей оформления →",
    featuresHeading: "Всё необходимое для оформления ссылок",
    featureStyles: "{count} стилей",
    featureStylesDetail: "APA, MLA, Chicago и другие",
    featureBibliographies: "Несколько библиографий",
    featureBibliographiesDetail: "Отдельно для каждой работы",
    featureBookSearch: "Поиск книг",
    featureBookSearchDetail: "По названию или автору",
    featureExport: "Экспорт куда угодно",
    featureExportDetail: "BibTeX, Word, RIS, CSV",
    featureDarkMode: "Тёмная тема",
    featureDarkModeDetail: "Комфортно для глаз",
    featureNoSignup: "Без регистрации",
    featureNoSignupDetail: "Всегда бесплатно, без платной подписки",
    aboutHeading: "Бесплатный генератор ссылок для студентов и исследователей",
    aboutBody:
      "CitationEasy поддерживает более 10 000 научных стилей оформления. Нужен ли вам APA для психологии, MLA для филологии, Chicago для истории или Vancouver для медицинских журналов — оформление берётся из официального описания самого стиля, а не из приблизительной копии.",
    howItWorksHeading: "Как это работает",
    howItWorksStep1:
      "Вставьте DOI, ссылку, ISBN, идентификатор PubMed или arXiv либо запись BibTeX; книгу можно найти и по названию.",
    howItWorksStep2:
      "Выберите стиль оформления. Начните печатать, чтобы искать среди всех {count} стилей.",
    howItWorksStep3:
      "Скопируйте готовое описание или сохраните его в библиографию и выгрузите в Word, BibTeX или RIS.",
    privacyNote:
      "Библиография хранится в вашем собственном браузере. Аккаунт не нужен, и ничего не отправляется на сервер.",
  },

  hubs: {
    toolsTitle: "Бесплатные инструменты для письма и оформления ссылок",
    toolsIntro:
      "{count} инструментов прямо в браузере: генераторы для каждого типа источника, счётчики слов и символов, оценка читаемости, средства форматирования и конвертеры. Все бесплатные и мгновенные.",
    stylesTitle: "Все стили оформления",
    stylesIntro:
      "Все {count} стилей проекта Citation Style Language с поиском и фильтрами по стране, предмету и научной области.",
    guidesTitle: "Руководства по оформлению ссылок и научному письму",
    guidesIntro:
      "Подробные руководства о том, как оформлять ссылки на разные типы источников, оценивать найденное и писать лучше.",
    howToCiteTitle: "Как сослаться на любой источник",
    howToCiteIntro:
      "Пошаговые страницы, сочетающие каждый распространённый тип источника с основными стилями оформления — с реальным разобранным примером.",
    faqTitle: "Частые вопросы об оформлении ссылок",
    faqIntro:
      "Короткие и точные ответы на вопросы, которые студенты действительно задают при оформлении ссылок.",
    glossaryTitle: "Глоссарий библиографических терминов",
    glossaryIntro:
      "Понятные определения терминов, которые встречаются в руководствах по стилю и в заданиях.",
    openHub: "Открыть",
  },

  styleLanding: {
    metaTitle: "Бесплатный генератор ссылок {style}",
    metaDescription:
      "Оформляйте ссылки в стиле {style} бесплатно. Вставьте DOI, ссылку, ISBN или BibTeX и получите библиографическое описание и внутритекстовую ссылку в правильном формате {style}.",
    heading: "Генератор ссылок {style}",
    intro:
      "Создавайте точные ссылки в стиле {style} на книги, журнальные статьи и веб-страницы одним щелчком. Бесплатно и без регистрации.",
    aboutHeading: "О стиле {style}",
    whenToUseHeading: "Когда применяется {style}",
    factsHeading: "{style} кратко",
    factEdition: "Издание",
    factSystem: "Система ссылок",
    factInText: "Формат в тексте",
    factReferenceList: "Название списка",
    factFields: "Распространён в",
    systemAuthorDate: "Автор–дата",
    systemNumbered: "Числовая",
    systemFootnotes: "Подстрочные примечания",
    howToHeading: "Как пользоваться этим генератором {style}",
    howToStep1:
      "Вставьте в поле выше ссылку, DOI, ISBN или запись BibTeX либо найдите книгу по названию.",
    howToStep2:
      "Стиль {style} на этой странице уже выбран, так что можно сразу создавать описание.",
    howToStep3:
      "Скопируйте результат в свой документ или сохраните его и выгрузите весь список позже.",
    relatedHeading: "Больше материалов о стиле {style}",
    englishOnlyNote:
      "Подробные руководства по стилю {style} и примеры по типам источников доступны на английском языке.",
  },

  // The per-style pages at `/<locale>/citation-style/<slug>` — one per catalog style.
  //
  // The formatted examples the page is built around (the style's own output for a
  // fixed journal article, book and website) and the style's own name stay in
  // `src/data/citation-styles.ts` and `src/data/style-examples-generated.json`. They
  // are language-neutral: a citation rendered by the style's own CSL definition looks
  // the same whatever language the reader speaks, and "translating" one would make the
  // page wrong.
  //
  // The rest of what `src/data/**` supplies to these pages is NOT like that — see the
  // `generic*`, `discipline*` and `internationalLabel` keys below.
  citationStylePage: {
    notFoundTitle: "Стиль оформления не найден",
    metaTitle: "Генератор ссылок {style} - бесплатный формат {style}",
    metaFormatAndFields:
      "{style} — стиль {format}, который используется в {fields}.",
    metaFormatOnly: "{style} — стиль {format}.",
    metaFieldsOnly: "{style} используется в {fields}.",
    metaPromiseNote:
      "Посмотрите настоящую сноску {style} и бесплатно создайте свою.",
    metaPromiseExamples:
      "Посмотрите настоящие примеры оформления {style} для журнальной статьи, книги и веб-сайта и бесплатно создайте свою ссылку.",
    ogKindFormat: "стиль {format}",
    ogKindDefault: "Стиль оформления",
    // Joins the style's discipline list: "psychology, education and nursing".
    disciplineConjunction: "и",
    // ---- Data-derived facts that are nonetheless mail-merged prose ----
    //
    // Every entry in `src/data/citation-styles-generated.ts` carries exactly the
    // two sentences below with their own name spliced in, exactly one region value
    // ("International" — that is `internationalLabel` above, reused rather than
    // duplicated), and discipline tokens drawn from a closed 26-word vocabulary. None
    // of that is a citation, so none of it is language-neutral the way the formatted
    // examples are. Left in `src/data/**` it renders English facts inside translated
    // chrome, which is precisely the hybrid page this tree exists to avoid.
    //
    // The page substitutes the two templates ONLY when a style's stored text is
    // byte-identical to the English template with its own name interpolated, so the
    // ~100 hand-curated styles keep their bespoke English descriptions instead of
    // being flattened into a generic sentence. `{name}` is the style's full name.
    genericDescription:
      "Стиль оформления для {name}. Из репозитория Citation Style Language.",
    genericWhenUsed:
      "Применяется при подаче материалов в издания или при цитировании в публикациях, которые используют стиль {name}.",

    // The 26 discipline tokens `style-examples-generated.json` uses. Each English
    // value is the exact string the page printed before these keys existed — the raw
    // token with hyphens turned into spaces — so `generic-base` reads "generic base"
    // and `political_science` keeps its underscore. An unknown token (a new one from
    // upstream CSL) falls back to that same prettified form rather than to a key name.
    disciplineAnthropology: "антропология",
    disciplineAstronomy: "астрономия",
    disciplineBiology: "биология",
    disciplineBotany: "ботаника",
    disciplineChemistry: "химия",
    disciplineCommunications: "коммуникации",
    disciplineEngineering: "инженерия",
    disciplineGenericBase: "общее",
    disciplineGeography: "география",
    disciplineGeology: "геология",
    disciplineHistory: "история",
    disciplineHumanities: "гуманитарные науки",
    disciplineLaw: "право",
    disciplineLinguistics: "лингвистика",
    disciplineLiterature: "литература",
    disciplineMath: "математика",
    disciplineMedicine: "медицина",
    disciplinePhilosophy: "философия",
    disciplinePhysics: "физика",
    disciplinePoliticalScience: "политология",
    disciplinePsychology: "психология",
    disciplineScience: "наука",
    disciplineSocialScience: "социальные науки",
    disciplineSociology: "социология",
    disciplineTheology: "теология",
    disciplineZoology: "зоология",

    // Plain-language descriptions of the citation-format classes the CSL definitions
    // declare. `{format}` in the fallback is the raw class name from the data.
    formatClassAuthorDate:
      "стиль «автор — дата»: внутритекстовые ссылки называют автора и год, а список литературы упорядочен по алфавиту фамилий авторов",
    formatClassNumeric:
      "числовой стиль: источники нумеруются в порядке первого упоминания, и внутритекстовые ссылки используют эти номера",
    formatClassNote:
      "стиль на основе примечаний: ссылки оформляются как сноски или концевые примечания, а не как скобки в тексте",
    formatClassLabel:
      "стиль с меткой: внутритекстовые ссылки используют краткую метку, составленную из фамилии автора и года",
    formatClassAuthor:
      "стиль «только автор»: внутритекстовые ссылки называют только автора, а полные сведения приводятся в списке литературы",
    formatClassOther: "стиль {format}",
    breadcrumbStyles: "Стили оформления",
    internationalLabel: "Международный",
    heading: "Генератор ссылок {style}",
    intro:
      "Создавайте точные ссылки {style} на книги, статьи и веб-сайты одним щелчком.",
    examplesHeading: "Примеры оформления {style}",
    examplesIntro: "Одни и те же три источника, оформленные в стиле {style}:",
    examplesIntroWithFormat:
      "Одни и те же три источника, оформленные в стиле {style} — {format}:",
    examplesNoteOnlyIntro:
      "{style} — стиль на основе примечаний: в нём нет списка литературы, и каждая ссылка оформляется как сноска. Вот наша примерная журнальная статья, оформленная по стилю {style}:",
    labelJournalArticle: "Журнальная статья",
    labelBook: "Книга",
    labelWebsite: "Веб-сайт",
    labelFootnote: "Сноска (журнальная статья)",
    labelInText: "Ссылка в тексте (для журнальной статьи)",
    aboutHeading: "О стиле {style}",
    whenToUseLabel: "Когда применять {style}:",
    commonInLabel: "Распространён в:",
    subjectAreasLabel: "Предметные области:",
    formattingRulesLabel: "Правила оформления:",
    parentStylePrefix: "{style} наследует правила оформления стиля",
    parentStyleSuffix: ", родительского стиля, на основе которого он построен.",
    howToHeading: "Как пользоваться этим генератором {style}",
    howToBody:
      "Вставьте DOI, ссылку на новостную статью или веб-страницу либо необработанный BibTeX в поле выше. Также можно найти книгу по названию или автору и сослаться на неё по ISBN. Выберите «{style}» в списке стилей (на этой странице он уже выбран заранее), затем нажмите «Создать ссылку». Скопируйте результат в свой список литературы или библиографию. Перед копированием можно отредактировать созданную запись (например, исправить название или добавить дату).",
    faqHeading: "Часто задаваемые вопросы о стиле {style}",
    faqWhatIsQ: "Что такое {style}?",
    faqWhenQ: "Когда следует использовать {style}?",
    faqInTextQ: "Как выглядит ссылка в тексте в стиле {style}?",
    faqInTextA:
      "{style} — {format}. Ссылка на нашу примерную журнальную статью в тексте выглядит так: {example}",
    faqReferenceQ: "Как выглядит запись в списке литературы {style}?",
    faqReferenceA:
      "Журнальная статья, оформленная по стилю {style}, выглядит так: {example}",
    faqWhereQ: "Где обычно используется {style}?",
    faqWhereA: "{style} используется в {region}. {whenUsed}",
    faqRegionDefault: "международном масштабе",
    faqGenerateQ: "Как создать ссылку {style}?",
    faqGenerateA:
      "Используйте бесплатный генератор на этой странице: вставьте DOI, URL (например, ссылку на новостную статью) или BibTeX, либо найдите книгу по названию или автору. Выберите {style} в качестве стиля оформления и нажмите «Создать», чтобы получить готовую ссылку, которую можно скопировать в свою работу или библиографию.",
    footerSupports:
      "поддерживает множество стилей оформления со всего мира. Наш генератор использует стили Citation Style Language (CSL) из",
    footerRepoLink: "официального репозитория CSL",
  },

  // The source × style pages at `/<locale>/how-to-cite/<slug>` — 1,290 combinations.
  //
  // Same division as above: the citation templates, the worked examples generated from
  // each style's own CSL definition, the in-text samples and the hand-checked
  // formatting rules stay in the page module and in
  // `src/data/how-to-cite-examples-generated.json`. They are the citations themselves,
  // not prose about them. Source names, style names and editions come from
  // `src/data/how-to-cite.ts` and arrive here as placeholder values.
  crossLinks: {
    generateHeading: "Создать эту ссылку",
    generateBody:
      "Вставьте URL, DOI, ISBN или данные источника — и получите готовую ссылку на {source} в стиле {style}.",
    generateCta: "Открыть {tool} →",
    guideHeading: "Подробнее",
    guideCta: "Прочитать полное руководство: {guide}",
    howToCiteHeading: "Как цитировать {source} в каждом стиле",
    howToCiteBody:
      "Правила оформления, шаблоны и разобранные примеры для самых востребованных стилей.",
    howToCiteMore: "Все типы источников и стили →",
    citeNowHeading: "Оформить ссылку на {source} в стиле {style} сейчас",
    citeNowHowTo: "Правила оформления и разобранные примеры",
    citeNowTool: "Создать с помощью инструмента {tool}",
    citeNowHub: "Генератор ссылок {style}",
    hubSourcesHeading:
      "Как цитировать распространённые источники в стиле {style}",
    hubGuidesHeading: "Руководства по {style}",
    hubCompareHeading: "Сравнить {style} с другими стилями",
    moreInCollection: "Ещё в разделе «{collection}»",
    seeAllInCollection: "Все инструменты раздела «{collection}»",
  },

  howToCitePage: {
    notFoundTitle: "Страница не найдена",
    title: "Как процитировать {source} в стиле {style} ({edition})",
    metaTitle:
      "Как процитировать {source} в стиле {style} [{edition}, обновлено в 2026 году]",
    metaDescription:
      "Узнайте, как оформлять ссылки на {description} в стиле {style} ({edition}). Бесплатные примеры, шаблоны и руководства по ссылкам в тексте.",
    keywordCite: "{source} {style} оформление",
    keywordCitation: "ссылка {style} {source}",
    keywordHowTo: "{source} как оформить ссылку",
    keywordExample: "пример ссылки {style}",
    keywordReference: "{source} в списке литературы {style}",
    // What each style calls the list at the back of the paper, in the two casings the
    // prose needs. MLA says "Works Cited", Chicago and the legal styles "Bibliography".
    refListWorksCited: "Список использованных источников",
    refListWorksCitedPage: "Список использованных источников",
    refListBibliography: "Библиография",
    refListBibliographyLower: "Библиография",
    refListReferenceList: "Список литературы",
    refListReferenceListLower: "Список литературы",
    backLink: "← Все руководства по оформлению",
    lead: "Узнайте, как оформлять ссылки на {description} в стиле {style} ({edition}). В этом руководстве — формат списка литературы, примеры ссылок в тексте и основные правила оформления.",
    referenceFormatHeading: "{style}: формат «{list}»",
    referenceFormatIntro:
      "Вот стандартный формат {style} для ссылки на {source} в разделе «{list}»:",
    noTemplateNote:
      "Используйте стандартный шаблон {style} для этого типа источника.",
    workedHeading: "Пример ссылки на {source} в стиле {style}",
    workedIntro:
      "Полная ссылка на {source} в стиле {style}, оформленная по официальному описанию стиля {style} в формате CSL — тем же движком, что работает в генераторе на этом сайте:",
    workedNoteOnlyIntro:
      "Если вы ссылаетесь на {source}, {style} не предусматривает отдельной записи в разделе «{list}» — такой источник цитируется только в примечании. Вот это примечание, оформленное по официальному описанию стиля {style} в формате CSL:",
    workedOscolaNote:
      "Результат OSCOLA, который создаёт этот сайт, следует стилю CSL 4-го издания, потому что в репозитории Citation Style Language ещё не опубликован стиль CSL 5-го издания. Поправьте его вручную: замените каждое ibid кратким названием и (n X), используйте идентификаторы судов из 5-го издания, возьмите краткую форму закона в одинарные кавычки и предпочитайте постоянную ссылку или DOI дате обращения",
    workedCheckedIntro:
      "Полная ссылка на {source} в стиле {style}, составленная вручную и сверенная с официальными рекомендациями {style} для этого типа источника:",
    workedCheckedNoteOnlyIntro:
      "Если вы ссылаетесь на {source}, {style} не предусматривает отдельной записи в разделе «{list}» — такой источник цитируется только в примечании. Вот это примечание, составленное вручную и сверенное с официальными рекомендациями {style}:",
    workedInTextLabel: "Соответствующая ссылка в тексте:",
    inTextHeading: "Ссылка в тексте: {style}",
    inTextIntro:
      "Используйте один из этих форматов при ссылке на источник в тексте своей работы:",
    inTextParenthetical: "В скобках",
    inTextNarrative: "В тексте",
    rulesHeading: "Основные правила оформления {style}",
    stepsHeading: "Пошаговая инструкция",
    step1Label: "Соберите сведения об источнике:",
    step1Body:
      "Если ваш источник — {source}, соберите имя автора, название, дату публикации и URL или DOI.",
    step2Label: "Оформите ссылку:",
    step2Body:
      "Расположите элементы по шаблону {style} ({edition}), показанному выше.",
    step3Label: "Создайте ссылку в тексте:",
    step3Body:
      "Добавьте в текст своей работы ссылку в скобках или в тексте — там, где вы упоминаете этот источник.",
    step4Label: "Добавьте в раздел «{list}»:",
    step4Body: "Включите полностью оформленную ссылку в конец своей работы.",
    step5Label: "Проверьте оформление:",
    step5Body:
      "Убедитесь, что курсив, пунктуация, использование заглавных букв и висячий отступ соответствуют требованиям {style}.",
    ctaHeading: "Создайте эту ссылку автоматически",
    ctaBody:
      "Не тратьте время на ручное оформление. Вставьте DOI, URL или ISBN в CitationEasy и получите безупречно оформленную ссылку {style} за считаные секунды.",
    ctaButton: "Оформить в {style} →",
    otherStylesHeading: "Как процитировать {source} в других стилях",
    comboLink: "{source} в стиле {style}",
    otherSourcesHeading: "Оформить другие источники в стиле {style}",
    resourcesHeading: "Дополнительные материалы",
    resourceGenerator: "Бесплатный генератор ссылок ({count} стиля)",
    resourceTools: "Бесплатные инструменты для письма",
    resourceCompare: "Сравнить стили оформления",
    resourceGuides: "Все руководства по оформлению",
    resourceCheatSheets: "Шпаргалки (APA, MLA, Chicago)",
    resourceGlossary:
      "Глоссарий терминов оформления (et al., ibid., DOI, висячий отступ)",
    // HowTo structured data. Deliberately worded differently from the visible steps
    // above: the schema describes the task generically, the page walks the reader
    // through this particular source and style.
    schemaStep1Name: "Соберите сведения об источнике",
    schemaStep1Text:
      "Соберите все необходимые сведения об источнике ({source}): автора, название, дату и URL или DOI.",
    schemaStep2Name: "Оформите в стиле {style}",
    schemaStep2Text:
      "Следуйте правилам оформления {style} ({edition}), чтобы расположить элементы ссылки в правильном порядке.",
    schemaStep3Name: "Создайте ссылку в тексте",
    schemaStep3Text:
      "Добавьте в свою работу соответствующую ссылку в тексте, оформленную по формату {style}.",
    schemaStep4Name: "Добавьте в список литературы",
    schemaStep4Text:
      "Включите полную ссылку в раздел «{list}» в конце своей работы.",
    faqHowQ: "Как процитировать {source} в стиле {style}?",
    faqHowA:
      "Чтобы процитировать {source} в стиле {style} ({edition}), укажите автора, название, дату и место публикации источника. Используйте наш бесплатный генератор ссылок для автоматического оформления.",
    faqFormatQ: "Какой формат {style} используется для ссылки на {source}?",
    faqFormatA: "Ссылка на {source} в стиле {style} оформляется так: {example}",
    faqFormatFallback:
      "Формат {style} требует определённых элементов — автора, названия, даты и места публикации — расположенных в конкретном порядке.",
    faqInTextQ: "Как сослаться на {source} в тексте работы в стиле {style}?",
    faqInTextA:
      "В стиле {style} ссылка в тексте для примера выше выглядит так: {example}",
  },

  // The 43 source types the how-to-cite pages are built from (`SOURCE_TYPES` in
  // `src/data/how-to-cite.ts`), in the five forms those pages print. Each form is a whole
  // phrase, never an article and a noun joined in code: an article agrees with its noun
  // in gender, number and case, elides in French and Italian, and has no counterpart
  // at all in Polish, Russian or Japanese.
  //
  // - `…Name` ("Book") is the type on its own, as a label: `howToCitePage.comboLink`.
  //   English also lower-cases it into the `keyword*` templates.
  // - `…Title` ("a Book") is the type as the object of "cite" in a title or heading:
  //   `title`, `metaTitle`, `workedHeading` and `otherStylesHeading`, plus
  //   `crossLinks.generateBody`, `howToCiteHeading` and `citeNowHeading`. Through
  //   `title` it is also the HowTo name, the OG card and every link to the page.
  // - `…Phrase` ("a book") is the same inside a sentence: `referenceFormatIntro`,
  //   `workedIntro`, `workedNoteOnlyIntro` and the five `faq*` questions and answers.
  // - `…Noun` ("book") is the bare noun inside a sentence, where English puts "your" in
  //   front of it: `step1Body` and `schemaStep1Text`. A translation also uses it in the
  //   `keyword*` templates, which read as search queries.
  // - `…Description` is what the type covers: `{description}` in `lead` and
  //   `metaDescription`.
  //
  // A language with case picks one case per form and words every template above around
  // it — German writes Title and Phrase in the accusative, Polish and Russian write Name
  // and Noun in the nominative. Changing a form's case means re-reading every template
  // that receives it. A key missing here falls back to the English data
  // (`howToCiteSourceForms`), so a new source type renders in English, not as a key.
  // Russian: Name, Noun nominative; Title, Phrase, Description accusative ("книгу").
  howToCiteSources: {
    websiteName: "Веб-сайт",
    websiteTitle: "веб-сайт",
    websitePhrase: "веб-сайт",
    websiteNoun: "веб-сайт",
    websiteDescription: "веб-страницы, онлайн-статьи и другой веб-контент",

    bookName: "Книга",
    bookTitle: "книгу",
    bookPhrase: "книгу",
    bookNoun: "книга",
    bookDescription: "печатные и электронные книги",

    journalArticleName: "Журнальная статья",
    journalArticleTitle: "журнальную статью",
    journalArticlePhrase: "журнальную статью",
    journalArticleNoun: "журнальная статья",
    journalArticleDescription: "рецензируемые статьи из научных журналов",

    youtubeVideoName: "Видео на YouTube",
    youtubeVideoTitle: "видео с YouTube",
    youtubeVideoPhrase: "видео с YouTube",
    youtubeVideoNoun: "видео на YouTube",
    youtubeVideoDescription: "ролики с YouTube и другие онлайн-видео",

    podcastName: "Подкаст",
    podcastTitle: "подкаст",
    podcastPhrase: "подкаст",
    podcastNoun: "подкаст",
    podcastDescription: "отдельные выпуски и целые серии подкастов",

    newspaperArticleName: "Статья в газете",
    newspaperArticleTitle: "статью в газете",
    newspaperArticlePhrase: "статью в газете",
    newspaperArticleNoun: "статья в газете",
    newspaperArticleDescription: "статьи из печатных и онлайн-газет",

    magazineArticleName: "Статья в популярном журнале",
    magazineArticleTitle: "статью в популярном журнале",
    magazineArticlePhrase: "статью в популярном журнале",
    magazineArticleNoun: "статья в популярном журнале",
    magazineArticleDescription:
      "статьи из печатных и онлайн-журналов для широкой аудитории",

    blogPostName: "Запись в блоге",
    blogPostTitle: "запись в блоге",
    blogPostPhrase: "запись в блоге",
    blogPostNoun: "запись в блоге",
    blogPostDescription: "записи в блогах и авторские колонки в интернете",

    wikipediaName: "Википедия",
    wikipediaTitle: "Википедию",
    wikipediaPhrase: "Википедию",
    wikipediaNoun: "Википедия",
    wikipediaDescription: "статьи Википедии и других вики-проектов",

    pdfName: "PDF-документ",
    pdfTitle: "PDF-документ",
    pdfPhrase: "PDF-документ",
    pdfNoun: "PDF-документ",
    pdfDescription: "документы и отчёты в формате PDF",

    interviewName: "Интервью",
    interviewTitle: "интервью",
    interviewPhrase: "интервью",
    interviewNoun: "интервью",
    interviewDescription: "личные, опубликованные и эфирные интервью",

    socialMediaName: "Публикация в социальных сетях",
    socialMediaTitle: "публикацию в социальных сетях",
    socialMediaPhrase: "публикацию в социальных сетях",
    socialMediaNoun: "публикация в социальных сетях",
    socialMediaDescription:
      "твиты, публикации в Instagram и Facebook, а также видео в TikTok",

    governmentDocumentName: "Государственный документ",
    governmentDocumentTitle: "государственный документ",
    governmentDocumentPhrase: "государственный документ",
    governmentDocumentNoun: "государственный документ",
    governmentDocumentDescription:
      "правительственные доклады, законодательные акты и официальные документы",

    dissertationName: "Диссертация или дипломная работа",
    dissertationTitle: "диссертацию или дипломную работу",
    dissertationPhrase: "диссертацию или дипломную работу",
    dissertationNoun: "диссертация или дипломная работа",
    dissertationDescription: "докторские и магистерские диссертации",

    conferencePaperName: "Доклад на конференции",
    conferencePaperTitle: "доклад на конференции",
    conferencePaperPhrase: "доклад на конференции",
    conferencePaperNoun: "доклад на конференции",
    conferencePaperDescription: "материалы и доклады конференций",

    lectureNotesName: "Лекция или презентация PowerPoint",
    lectureNotesTitle: "лекцию или презентацию PowerPoint",
    lectureNotesPhrase: "лекцию или презентацию PowerPoint",
    lectureNotesNoun: "лекция или презентация PowerPoint",
    lectureNotesDescription: "лекции, слайды и учебные материалы курсов",

    webinarName: "Вебинар",
    webinarTitle: "вебинар",
    webinarPhrase: "вебинар",
    webinarNoun: "вебинар",
    webinarDescription: "вебинары и онлайн-семинары в прямом эфире и в записи",

    onlineCourseName: "Онлайн-курс",
    onlineCourseTitle: "онлайн-курс",
    onlineCoursePhrase: "онлайн-курс",
    onlineCourseNoun: "онлайн-курс",
    onlineCourseDescription:
      "онлайн-курсы и MOOC (Coursera, edX, Udemy, FutureLearn)",

    presentationSlidesName: "Презентация PowerPoint",
    presentationSlidesTitle: "презентацию PowerPoint",
    presentationSlidesPhrase: "презентацию PowerPoint",
    presentationSlidesNoun: "презентация PowerPoint",
    presentationSlidesDescription:
      "презентации PowerPoint и другие наборы слайдов",

    imageName: "Изображение или фотография",
    imageTitle: "изображение или фотографию",
    imagePhrase: "изображение или фотографию",
    imageNoun: "изображение или фотография",
    imageDescription:
      "фотографии, произведения искусства, диаграммы и изображения из интернета",

    movieName: "Фильм",
    movieTitle: "фильм",
    moviePhrase: "фильм",
    movieNoun: "фильм",
    movieDescription: "фильм",

    documentaryName: "Документальный фильм",
    documentaryTitle: "документальный фильм",
    documentaryPhrase: "документальный фильм",
    documentaryNoun: "документальный фильм",
    documentaryDescription: "документальные и неигровые фильмы",

    tvShowName: "Телепередача",
    tvShowTitle: "телепередачу",
    tvShowPhrase: "телепередачу",
    tvShowNoun: "телепередача",
    tvShowDescription: "телепередачу или телесериал",

    songName: "Песня или музыкальное произведение",
    songTitle: "песню или музыкальное произведение",
    songPhrase: "песню или музыкальное произведение",
    songNoun: "песня или музыкальное произведение",
    songDescription: "песню или музыкальную запись",

    poemName: "Стихотворение",
    poemTitle: "стихотворение",
    poemPhrase: "стихотворение",
    poemNoun: "стихотворение",
    poemDescription:
      "стихотворения и другие поэтические произведения из антологий и сборников",

    courtCaseName: "Судебное дело",
    courtCaseTitle: "судебное дело",
    courtCasePhrase: "судебное дело",
    courtCaseNoun: "судебное дело",
    courtCaseDescription: "судебное дело или судебное решение",

    patentName: "Патент",
    patentTitle: "патент",
    patentPhrase: "патент",
    patentNoun: "патент",
    patentDescription:
      "патент или другой документ в сфере интеллектуальной собственности",

    encyclopediaName: "Статья в энциклопедии",
    encyclopediaTitle: "статью в энциклопедии",
    encyclopediaPhrase: "статью в энциклопедии",
    encyclopediaNoun: "статья в энциклопедии",
    encyclopediaDescription: "статью или запись в энциклопедии",

    dictionaryName: "Словарная статья",
    dictionaryTitle: "словарную статью",
    dictionaryPhrase: "словарную статью",
    dictionaryNoun: "словарная статья",
    dictionaryDescription: "определение или статью из словаря",

    datasetName: "Набор данных",
    datasetTitle: "набор данных",
    datasetPhrase: "набор данных",
    datasetNoun: "набор данных",
    datasetDescription: "набор данных или базу данных",

    softwareName: "Программа или приложение",
    softwareTitle: "программу или приложение",
    softwarePhrase: "программу или приложение",
    softwareNoun: "программа или приложение",
    softwareDescription:
      "программное обеспечение, приложение или компьютерную программу",

    videoGameName: "Видеоигра",
    videoGameTitle: "видеоигру",
    videoGamePhrase: "видеоигру",
    videoGameNoun: "видеоигра",
    videoGameDescription:
      "видеоигры и другое интерактивное игровое программное обеспечение",

    pressReleaseName: "Пресс-релиз",
    pressReleaseTitle: "пресс-релиз",
    pressReleasePhrase: "пресс-релиз",
    pressReleaseNoun: "пресс-релиз",
    pressReleaseDescription: "пресс-релиз или информационное сообщение",

    reportName: "Отчёт",
    reportTitle: "отчёт",
    reportPhrase: "отчёт",
    reportNoun: "отчёт",
    reportDescription: "отчёт или аналитический доклад",

    preprintName: "Препринт",
    preprintTitle: "препринт",
    preprintPhrase: "препринт",
    preprintNoun: "препринт",
    preprintDescription: "статьи с arXiv, bioRxiv и других серверов препринтов",

    bookChapterName: "Глава книги",
    bookChapterTitle: "главу книги",
    bookChapterPhrase: "главу книги",
    bookChapterNoun: "глава книги",
    bookChapterDescription: "главы и статьи в коллективных сборниках",

    chatgptName: "ChatGPT",
    chatgptTitle: "ChatGPT",
    chatgptPhrase: "ChatGPT",
    chatgptNoun: "ChatGPT",
    chatgptDescription: "ChatGPT и другие инструменты генеративного ИИ",

    bibleName: "Библия",
    bibleTitle: "Библию",
    biblePhrase: "Библию",
    bibleNoun: "Библия",
    bibleDescription: "Библию, другие священные писания и религиозные тексты",

    tedTalkName: "Лекция TED",
    tedTalkTitle: "лекцию TED",
    tedTalkPhrase: "лекцию TED",
    tedTalkNoun: "лекция TED",
    tedTalkDescription: "лекции TED и записи докладов с конференций",

    emailName: "Электронное письмо",
    emailTitle: "электронное письмо",
    emailPhrase: "электронное письмо",
    emailNoun: "электронное письмо",
    emailDescription:
      "электронные письма, обычные письма и другую личную переписку",

    redditName: "Пост на Reddit или форуме",
    redditTitle: "пост на Reddit или форуме",
    redditPhrase: "пост на Reddit",
    redditNoun: "пост на Reddit",
    redditDescription:
      "ветки обсуждений на Reddit, сессии AMA и сообщения на интернет-форумах",

    tweetName: "Пост в X (Twitter)",
    tweetTitle: "пост в X (Twitter)",
    tweetPhrase: "пост в X",
    tweetNoun: "пост в X",
    tweetDescription: "твиты и посты в X (ранее Twitter)",

    mapName: "Карта",
    mapTitle: "карту",
    mapPhrase: "карту",
    mapNoun: "карта",
    mapDescription:
      "печатные карты, атласы и интерактивные карты (например, Google Maps)",

    claudeName: "Claude",
    claudeTitle: "Claude",
    claudePhrase: "Claude",
    claudeNoun: "Claude",
    claudeDescription: "чаты с Claude и другие ответы ИИ от Anthropic",

    geminiName: "Gemini",
    geminiTitle: "Gemini",
    geminiPhrase: "Gemini",
    geminiNoun: "Gemini",
    geminiDescription: "чаты с Google Gemini и ответы ИИ",

    copilotName: "Microsoft Copilot",
    copilotTitle: "Microsoft Copilot",
    copilotPhrase: "Microsoft Copilot",
    copilotNoun: "Microsoft Copilot",
    copilotDescription: "чаты с Microsoft Copilot и ответы ИИ",

    perplexityName: "Perplexity",
    perplexityTitle: "Perplexity",
    perplexityPhrase: "Perplexity",
    perplexityNoun: "Perplexity",
    perplexityDescription:
      "ответы и ветки Perplexity AI, а также источники, на которые они ссылаются",

    aiImageName: "Изображение, созданное ИИ",
    aiImageTitle: "изображение, созданное ИИ",
    aiImagePhrase: "изображение, созданное ИИ",
    aiImageNoun: "изображение, созданное ИИ",
    aiImageDescription:
      "изображения, созданные с помощью DALL·E, Midjourney, Gemini и других инструментов ИИ",

    tiktokName: "Видео в TikTok",
    tiktokTitle: "видео в TikTok",
    tiktokPhrase: "видео в TikTok",
    tiktokNoun: "видео в TikTok",
    tiktokDescription: "видео в TikTok и публикации авторов",

    instagramName: "Пост в Instagram",
    instagramTitle: "пост в Instagram",
    instagramPhrase: "пост в Instagram",
    instagramNoun: "пост в Instagram",
    instagramDescription: "посты, рилсы и сторис в Instagram",

    statuteName: "Закон или нормативный акт",
    statuteTitle: "закон или нормативный акт",
    statutePhrase: "закон или нормативный акт",
    statuteNoun: "закон или нормативный акт",
    statuteDescription: "законодательные акты, законы и кодексы",

    isoStandardName: "Стандарт ISO",
    isoStandardTitle: "стандарт ISO",
    isoStandardPhrase: "стандарт ISO",
    isoStandardNoun: "стандарт ISO",
    isoStandardDescription:
      "стандарты ISO, IEC и другие опубликованные технические стандарты",

    quranName: "Коран",
    quranTitle: "Коран",
    quranPhrase: "Коран",
    quranNoun: "Коран",
    quranDescription: "Коран на арабском языке или в переводе",

    ebookNoPageNumbersName: "Электронная книга без номеров страниц",
    ebookNoPageNumbersTitle: "электронную книгу без номеров страниц",
    ebookNoPageNumbersPhrase: "электронную книгу без номеров страниц",
    ebookNoPageNumbersNoun: "электронная книга без номеров страниц",
    ebookNoPageNumbersDescription:
      "электронные книги для Kindle, в формате EPUB и онлайн, у которых нет фиксированных номеров страниц",

    speechName: "Речь",
    speechTitle: "речь",
    speechPhrase: "речь",
    speechNoun: "речь",
    speechDescription: "речи, обращения и проповеди — вживую или в записи",

    letterName: "Письмо",
    letterTitle: "письмо",
    letterPhrase: "письмо",
    letterNoun: "письмо",
    letterDescription:
      "опубликованные письма, письма из архивов и открытые письма",

    secondarySourceName: "Вторичный источник",
    secondarySourceTitle: "вторичный источник",
    secondarySourcePhrase: "вторичный источник",
    secondarySourceNoun: "вторичный источник",
    secondarySourceDescription:
      "источник, который вы нашли процитированным или упомянутым в другой работе",
  },

  // ---------------------------------------------------------------------------
  // NOT YET TRANSLATED. These five sections were copied verbatim from `en.ts` so
  // this file still satisfies `Dictionary`; the page types they cover
  // (`taxonomy`, `compare`, `convert`) are deliberately absent from
  // TRANSLATED_PAGE_TYPES, so nothing publishes them in this language yet. The
  // translation pass replaces the strings and only then adds the types.
  // ---------------------------------------------------------------------------
  // The three browse-by-facet pages under `/<locale>/citation-styles/…` — 32 academic
  // fields, 68 countries and 39 subject categories, 139 pages in one section because
  // they share a shell, a breadcrumb trail and a styles browser.
  //
  // The style NAMES, slugs and the CSL catalog itself stay in `src/data/**`: those are
  // subject matter. What the facets themselves are called is not — "Political Science",
  // "United Kingdom" and "Film & Media" are ordinary nouns that every reader expects in
  // their own language, and there are only 139 of them in total (see the `academicFields`,
  // `regions` and `styleCategories` sections below).
  taxonomyPage: {
    // ---- /citation-styles/field/<slug> ----
    fieldNotFoundTitle: "Не найдено",
    fieldMetaTitle:
      "Стили оформления - {field}: лучшие стандарты цитирования [2026]",
    fieldMetaDescription:
      "Узнайте, какие стили оформления чаще всего используются в области «{field}». Найдите подходящий формат ссылок для своей работы, диссертации или статьи по направлению «{fieldLower}».",
    fieldOgTitle: "Стили оформления - {field}",
    fieldOgSubtitle: "Часто требуются: {styles}.",
    fieldOgKind: "По научной области",
    fieldKeywordStyle: "стиль оформления {field}",
    fieldKeywordReferencing: "оформление ссылок {field}",
    fieldKeywordBest: "лучший стиль оформления для направления «{fieldLower}»",
    fieldKeywordBibliography:
      "формат библиографии для направления «{fieldLower}»",
    fieldKeywordDiscipline: "стили оформления по научным областям",
    fieldBackLink: "← Все стили оформления",
    fieldHeading: "Стили оформления — {field}",
    fieldRecommendedHeading: "Рекомендуемые стили оформления",
    fieldRecommendedIntro:
      "Следующие стили оформления часто используются в исследованиях, журналах и учебных работах по направлению «{field}». Выберите стиль, чтобы узнать о нём подробнее и начать создавать ссылки.",
    fieldStyleFallback:
      "Стиль оформления, применяемый в области «{field}» и смежных дисциплинах.",
    fieldRelatedHeading: "Смежные направления",
    fieldRelatedIntro:
      "Изучите стили оформления, применяемые в смежных научных дисциплинах:",
    fieldCtaHeading: "Изучите все стили оформления",
    fieldCtaBody:
      "CitationEasy поддерживает {count} стилей оформления по всем научным областям. Просмотрите всю коллекцию, чтобы найти нужный формат.",
    fieldCtaButton: "Смотреть все стили →",
    fieldFaqWhichQ:
      "Какой стиль оформления используется в направлении «{field}»?",
    fieldFaqWhichA:
      "Стиль оформления, используемый в направлении «{field}», зависит от требований конкретного журнала, учебного заведения или преподавателя. Среди распространённых — {styles}. Всегда сверяйтесь с требованиями к заданию или журналу, в который вы подаёте материалы.",
    fieldFaqSameQ:
      "Все ли журналы по направлению «{field}» используют один и тот же стиль?",
    fieldFaqSameA:
      "Нет, не все журналы по направлению «{field}» используют один и тот же стиль оформления. Хотя некоторые стили более распространены в этой области, у отдельных журналов могут быть собственные требования к оформлению. Всегда проверяйте правила подачи материалов конкретного журнала перед подготовкой рукописи.",
    fieldFaqChooseQ:
      "Как выбрать стиль оформления для работы по направлению «{field}»?",
    fieldFaqChooseA:
      "Чтобы выбрать стиль оформления для работы по направлению «{field}», сначала проверьте, не указан ли обязательный стиль преподавателем или журналом. Если нет — используйте один из рекомендуемых для направления «{field}» стилей, перечисленных выше. CitationEasy поддерживает более {count} стилей и может бесплатно оформить ссылки в любом из них.",

    // ---- /citation-styles/country/<slug> ----
    countryNotFoundTitle: "Страна не найдена",
    countryMetaTitle: "Стили оформления - {country}: APA, MLA и другие",
    countryMetaDescription:
      "Стили оформления, используемые в стране «{country}». Бесплатный генератор ссылок для форматов, принятых в стране «{country}».",
    countryOgTitle: "Стили оформления, используемые в стране «{country}»",
    countryOgKind: "По странам",
    countryHeading: "Стили оформления — {country}",
    countryIntroOne:
      "{count} стиль оформления, обычно используемый в стране «{country}» или связанный с ней. Выберите его, чтобы открыть отдельный генератор.",
    countryIntroMany:
      "{count} стилей оформления, обычно используемых в стране «{country}» или связанных с ней. Выберите нужный, чтобы открыть отдельный генератор.",
    countryBrowserTitle: "Стили оформления — {country}",

    // ---- /citation-styles/type/<slug> ----
    typeNotFoundTitle: "Тип не найден",
    typeMetaTitle: "Стили оформления - {type}: бесплатный генератор",
    typeMetaDescription:
      "Стили оформления для направления «{typeLower}». APA, MLA, Vancouver и другие. Бесплатный генератор ссылок.",
    typeOgTitle: "Стили оформления - {type}",
    typeOgKind: "По предметной области",
    typeHeading: "Стили оформления — {type}",
    typeIntroOne:
      "{count} стиль оформления для направления «{typeLower}». Выберите его, чтобы открыть отдельный генератор с ответами на частые вопросы.",
    typeIntroMany:
      "{count} стилей оформления для направления «{typeLower}». Выберите нужный, чтобы открыть отдельный генератор с ответами на частые вопросы.",
    typeBrowserTitle: "Стили оформления — {type}",

    // ---- Shared chrome ----
    breadcrumbStyles: "Стили оформления",
    // Title case, because the BreadcrumbList markup says "Citation Styles" while the
    // visible trail says "Citation styles". Two keys rather than one so translating
    // either does not silently change the other.
    breadcrumbStylesSchema: "Стили оформления",
    breadcrumbByCountry: "По странам",
    breadcrumbByDiscipline: "По дисциплинам",
    allStylesLink: "← Все стили оформления",
    internationalLabel: "Международный",
  },

  // The 32 academic fields (`ACADEMIC_FIELDS` in src/data/style-pages.ts), keyed by
  // slug. Their one-sentence `description` is next door in `academicFieldDescriptions`.
  academicFields: {
    psychology: "Психология",
    education: "Образование",
    sociology: "Социология",
    anthropology: "Антропология",
    politicalScience: "Политология",
    economics: "Экономика",
    business: "Бизнес и менеджмент",
    literature: "Литература и языки",
    history: "История",
    philosophy: "Философия",
    law: "Право и юриспруденция",
    medicine: "Медицина и клинические науки",
    nursing: "Сестринское дело и акушерство",
    publicHealth: "Общественное здравоохранение и эпидемиология",
    pharmacy: "Фармация",
    biology: "Биология и науки о жизни",
    chemistry: "Химия",
    physics: "Физика",
    engineering: "Инженерия",
    computerScience: "Информатика",
    mathematics: "Математика и статистика",
    environmentalScience: "Наука об окружающей среде",
    earthScience: "Науки о Земле и геология",
    artHistory: "История искусств и изобразительное искусство",
    music: "Музыка и музыковедение",
    theology: "Теология и религиоведение",
    socialWork: "Социальная работа",
    linguistics: "Лингвистика",
    architecture: "Архитектура и градостроительство",
    filmMedia: "Кино и медиаисследования",
    journalism: "Журналистика и коммуникации",
    criminology: "Криминология и уголовное правосудие",
  },

  // The same 32 fields' one-sentence ledes — the opening paragraph of every
  // `/citation-styles/field/<slug>` page.
  //
  // Unlike everything above, these are hand-written per field rather than mail-merged
  // from a template, which is why the extraction pass left them in
  // `src/data/style-pages.ts`: translating them is a content job, not a string swap.
  // But "hand-written" describes how they were produced, not where they belong. With
  // the chrome translated and the lede still English, the page is the hybrid CLAUDE.md
  // calls worse than an honest redirect — translated furniture around an English core.
  // `academicFieldDescription()` (src/lib/i18n/data-labels.ts) falls back to the data
  // file's own value, so a field added upstream is untranslated rather than blank.
  academicFieldDescriptions: {
    psychology:
      "Стили оформления, распространённые в психологии, поведенческих науках и когнитивных исследованиях.",
    education:
      "Стили оформления для исследований в области образования, педагогики и разработки учебных программ.",
    sociology:
      "Стили оформления, применяемые в социологических исследованиях и социальной теории.",
    anthropology:
      "Стили оформления для антропологических и этнографических исследований.",
    politicalScience:
      "Стили оформления для исследований в области политологии, государственного управления и публичной политики.",
    economics:
      "Стили оформления, применяемые в исследованиях по экономике и эконометрике.",
    business:
      "Стили оформления для исследований в области бизнеса, менеджмента, маркетинга и финансов.",
    literature:
      "Стили оформления для литературоведческих, лингвистических и языковых исследований.",
    history:
      "Стили оформления для исторических исследований, историографии и архивных изысканий.",
    philosophy:
      "Стили оформления для философских работ и исследований по этике.",
    law: "Юридические стили оформления для судебных документов, юридических журналов и правовой науки.",
    medicine:
      "Стили оформления для медицинских исследований, клинических испытаний и здравоохранения.",
    nursing:
      "Стили оформления для исследований в сестринском деле и практики здравоохранения.",
    publicHealth:
      "Стили оформления для исследований в области общественного здравоохранения и эпидемиологии.",
    pharmacy:
      "Стили оформления для фармацевтических и фармакологических исследований.",
    biology:
      "Стили оформления для биологических исследований, экологии и генетики.",
    chemistry:
      "Стили оформления для исследований в области химии, биохимии и материаловедения.",
    physics:
      "Стили оформления для исследований в области физики, астрофизики и прикладной физики.",
    engineering:
      "Стили оформления для исследований в области инженерии и прикладных технологий.",
    computerScience:
      "Стили оформления для исследований в области информатики, искусственного интеллекта и программной инженерии.",
    mathematics:
      "Стили оформления для исследований в области математики, прикладной математики и статистики.",
    environmentalScience:
      "Стили оформления для экологических исследований и исследований в области устойчивого развития.",
    earthScience:
      "Стили оформления для исследований в области геологии, геофизики и наук о Земле.",
    artHistory:
      "Стили оформления для исследований в области истории искусств, визуальной культуры и музееведения.",
    music:
      "Стили оформления для исследований в области музыки, теории музыки и исполнительского искусства.",
    theology: "Стили оформления для теологических и религиоведческих трудов.",
    socialWork:
      "Стили оформления для исследований и практики в области социальной работы.",
    linguistics:
      "Стили оформления для исследований в области лингвистики, фонетики и языкознания.",
    architecture:
      "Стили оформления для исследований в области архитектуры, градостроительства и планирования.",
    filmMedia:
      "Стили оформления для исследований в области кино, телевидения, медиа и коммуникации.",
    journalism:
      "Стили оформления для исследований в области журналистики, медиаисследований и коммуникации.",
    criminology:
      "Стили оформления для исследований в области криминологии и уголовного правосудия.",
  },

  // The 68 country/region facets (`REGIONS` in src/data/citation-styles.ts), keyed by
  // slug. `getRegionCountryCode` still keys off the English data value, so translating these
  // moves the label without moving the flag.
  regions: {
    unitedStates: "США",
    unitedKingdom: "Великобритания",
    australia: "Австралия",
    canada: "Канада",
    newZealand: "Новая Зеландия",
    ireland: "Ирландия",
    southAfrica: "ЮАР",
    germany: "Германия",
    france: "Франция",
    spain: "Испания",
    italy: "Италия",
    netherlands: "Нидерланды",
    belgium: "Бельгия",
    switzerland: "Швейцария",
    austria: "Австрия",
    portugal: "Португалия",
    luxembourg: "Люксембург",
    sweden: "Швеция",
    norway: "Норвегия",
    denmark: "Дания",
    finland: "Финляндия",
    iceland: "Исландия",
    poland: "Польша",
    czechRepublic: "Чехия",
    hungary: "Венгрия",
    romania: "Румыния",
    russia: "Россия",
    ukraine: "Украина",
    greece: "Греция",
    turkey: "Турция",
    croatia: "Хорватия",
    slovenia: "Словения",
    slovakia: "Словакия",
    serbia: "Сербия",
    bulgaria: "Болгария",
    lithuania: "Литва",
    latvia: "Латвия",
    estonia: "Эстония",
    japan: "Япония",
    china: "Китай",
    southKorea: "Южная Корея",
    india: "Индия",
    singapore: "Сингапур",
    hongKong: "Гонконг",
    taiwan: "Тайвань",
    malaysia: "Малайзия",
    indonesia: "Индонезия",
    thailand: "Таиланд",
    vietnam: "Вьетнам",
    philippines: "Филиппины",
    pakistan: "Пакистан",
    bangladesh: "Бангладеш",
    sriLanka: "Шри-Ланка",
    israel: "Израиль",
    saudiArabia: "Саудовская Аравия",
    unitedArabEmirates: "Объединённые Арабские Эмираты",
    brazil: "Бразилия",
    mexico: "Мексика",
    argentina: "Аргентина",
    chile: "Чили",
    colombia: "Колумбия",
    peru: "Перу",
    venezuela: "Венесуэла",
    egypt: "Египет",
    nigeria: "Нигерия",
    kenya: "Кения",
    morocco: "Марокко",
    international: "Международный",
  },

  // The 39 subject categories (`CATEGORIES` in src/data/citation-styles.ts), keyed by
  // slug. The emoji beside each one stays in the data — it is language-neutral.
  styleCategories: {
    medicine: "Медицина",
    nursing: "Сестринское дело",
    publicHealth: "Общественное здравоохранение",
    pharmacy: "Фармация",
    dentistry: "Стоматология",
    veterinary: "Ветеринария",
    psychology: "Психология",
    sociology: "Социология",
    anthropology: "Антропология",
    politicalScience: "Политология",
    economics: "Экономика",
    education: "Образование",
    socialWork: "Социальная работа",
    biology: "Биология",
    chemistry: "Химия",
    physics: "Физика",
    environmentalScience: "Наука об окружающей среде",
    earthScience: "Науки о Земле и геология",
    agriculture: "Сельское хозяйство",
    ecology: "Экология",
    engineering: "Инженерия",
    computerScience: "Информатика",
    mathematics: "Математика",
    statistics: "Статистика",
    history: "История",
    literature: "Литература",
    philosophy: "Философия",
    linguistics: "Лингвистика",
    artHistory: "История искусств",
    music: "Музыка",
    filmMedia: "Кино и медиа",
    archaeology: "Археология",
    law: "Право",
    business: "Бизнес",
    architecture: "Архитектура",
    religion: "Религия и теология",
    geography: "География",
    general: "Общее / Междисциплинарное",
    other: "Другое",
  },

  // The closed vocabularies `STYLE_LANDING_PAGES` (src/data/style-pages.ts) draws on for
  // the 30 major styles: what each style calls its end-of-paper list, the shape of its
  // in-text citation, its edition, and the disciplines that require it. The comparison
  // pages print all four in a table and the field pages print two of them under every
  // style card, so leaving them in the data means a translated page with an English
  // table in the middle of it.
  //
  // Style NAMES (`name`, `fullName`) are NOT here: a style's official name is what it
  // is called everywhere. The 30 hand-written taglines are, in `styleTaglines` below.
  styleFacts: {
    // `referenceListName` — 6 distinct values across the 30 styles.
    listReferenceList: "Список литературы",
    listWorksCited: "Список использованных источников",
    listReferences: "Список источников",
    listBibliography: "Библиография",
    listTableOfAuthorities: "Таблица источников",
    listReferencesCited: "Цитированная литература",
    listLowerReferenceList: "список литературы",
    listLowerWorksCited: "список использованных источников",
    listLowerReferences: "список источников",
    listLowerBibliography: "библиография",
    listLowerTableOfAuthorities: "таблица источников",
    listLowerReferencesCited: "цитированная литература",

    // `inTextFormat` — 14 distinct values. "Author", "Year" and "Page" are slot names,
    // not part of the citation, so they read as English words on a Spanish page.
    inTextAuthorCommaYear: "(Автор, Год)",
    inTextAuthorPage: "(Автор Страница)",
    inTextAuthorYear: "(Автор Год)",
    inTextSuperscriptOrBracketed:
      "Надстрочные или заключённые в скобки номера (1)",
    inTextBracketedNumbers: "Номера в квадратных скобках [1]",
    inTextSuperscriptNumbers: "Надстрочные номера¹",
    inTextSuperscriptOrAuthorYear: "Надстрочные номера или (Автор Год)",
    inTextKeyBased: "Ссылки по ключу",
    inTextSuperscriptOrAuthorCommaYear: "Надстрочные номера или (Автор, Год)",
    inTextFootnotesCaseLegislation:
      "Сноски со ссылками на судебные дела и законодательство",
    inTextFootnotesSignals: "Сноски с сигнальными сокращениями",
    inTextFootnotesPinpoint: "Сноски с точными постраничными ссылками",
    inTextParenNumbers: "Номера в круглых скобках (1)",
    inTextItalicNumbers: "Курсивные номера (1)",

    // `edition` — 12 distinct values. The ordinal and the word "edition" translate; the
    // handbook name inside "Cite Them Right 11th edition" does not.
    edition4th: "4-е издание",
    edition5th: "5-е издание",
    edition7th: "7-е издание",
    edition8th: "8-е издание",
    edition9th: "9-е издание",
    edition11th: "11-е издание",
    edition18th: "18-е издание",
    edition22nd: "22-е издание",
    editionCiteThemRight11th: "Cite Them Right, 11-е издание",
    editionIcmjeStandard: "стандарт ICMJE",
    editionStandard: "стандартное",
    editionCurrent: "текущее",

    // `fields` — the 67 discipline names the 30 styles are tagged with.
    fieldAcoustics: "Акустика",
    fieldAnthropology: "Антропология",
    fieldAppliedPhysics: "Прикладная физика",
    fieldArchaeology: "Археология",
    fieldArts: "Искусство",
    fieldAstrophysics: "Астрофизика",
    fieldAustralianLaw: "Право Австралии",
    fieldBiochemistry: "Биохимия",
    fieldBiology: "Биология",
    fieldBiomedicalSciences: "Биомедицинские науки",
    fieldBiotechnology: "Биотехнологии",
    fieldBusiness: "Бизнес",
    fieldCellBiology: "Клеточная биология",
    fieldChemicalEngineering: "Химическая инженерия",
    fieldChemistry: "Химия",
    fieldClinicalResearch: "Клинические исследования",
    fieldComputerScience: "Информатика",
    fieldCondensedMatter: "Физика конденсированного состояния",
    fieldCourtDocuments: "Судебные документы",
    fieldCriminology: "Криминология",
    fieldCulturalStudies: "Культурология",
    fieldDemography: "Демография",
    fieldEcology: "Экология",
    fieldEducation: "Образование",
    fieldElectronics: "Электроника",
    fieldEngineering: "Инженерия",
    fieldEnvironmentalScience: "Наука об окружающей среде",
    fieldEpidemiology: "Эпидемиология",
    fieldEthnography: "Этнография",
    fieldGenetics: "Генетика",
    fieldGeology: "Геология",
    fieldGlobalHealth: "Глобальное здравоохранение",
    fieldHealthSciences: "Науки о здоровье",
    fieldHistory: "История",
    fieldHumanities: "Гуманитарные науки",
    fieldInformationSystems: "Информационные системы",
    fieldInformationTechnology: "Информационные технологии",
    fieldInternationalRelations: "Международные отношения",
    fieldJurisprudence: "Юриспруденция",
    fieldLanguages: "Языки",
    fieldLaw: "Право",
    fieldLawReview: "Юридический журнал",
    fieldLegalStudies: "Юридические науки",
    fieldLifeSciences: "Науки о жизни",
    fieldLiterature: "Литература",
    fieldMaterialsScience: "Материаловедение",
    fieldMathematics: "Математика",
    fieldMedicine: "Медицина",
    fieldMolecularBiology: "Молекулярная биология",
    fieldMultidisciplinary: "Междисциплинарная область",
    fieldMultidisciplinaryScience: "Междисциплинарная наука",
    fieldNaturalSciences: "Естественные науки",
    fieldNursing: "Сестринское дело",
    fieldPharmacy: "Фармация",
    fieldPhysics: "Физика",
    fieldPoliticalScience: "Политология",
    fieldPsychology: "Психология",
    fieldPublicHealth: "Общественное здравоохранение",
    fieldPublicPolicy: "Государственная политика",
    fieldPublishing: "Издательское дело",
    fieldScience: "Наука",
    fieldSciences: "Науки",
    fieldSocialSciences: "Социальные науки",
    fieldSocialWork: "Социальная работа",
    fieldSociology: "Социология",
    fieldSoftwareEngineering: "Программная инженерия",
    fieldTheology: "Теология",
  },

  // The 30 major styles' hero taglines (`STYLE_LANDING_PAGES[].tagline`), keyed by
  // slug.
  //
  // Per-page hand-written copy, not a template — which is why they outlived the
  // extraction pass in `src/data/style-pages.ts`. Three page types print them: the
  // style landing page's hero, the card for each recommended style on a field
  // taxonomy page, and the lower-cased clause inside a comparison page's opening
  // sentence ("APA (…) is the most widely used citation style in the social
  // sciences"). Leaving them in the data means an English sentence in the first
  // paragraph of an otherwise translated page. `styleTagline()`
  // (src/lib/i18n/data-labels.ts) falls back to the data file's own value.
  styleTaglines: {
    apa: "Самый распространённый стиль оформления в социальных науках",
    mla: "Стандартный стиль оформления для гуманитарных наук",
    chicago:
      "Самое авторитетное в Америке руководство по стилю для авторов, редакторов и издателей",
    harvard:
      "Самый популярный стиль оформления ссылок в университетах Великобритании и Австралии",
    vancouver:
      "Стандартный стиль оформления для медицинских и биомедицинских журналов",
    ieee: "Основной стиль оформления для инженерии и информатики",
    ama: "Стандарт оформления ссылок для американских медицинских журналов",
    turabian: "Упрощённая, студенческая версия стиля Chicago",
    cse: "Предпочтительный стиль оформления для естественных и точных наук",
    bibtex:
      "Формат библиографии для пользователей LaTeX и академической вёрстки",
    nature: "Стиль оформления ведущего мультидисциплинарного журнала мира",
    acs: "Стандарт оформления ссылок для химии и химических наук",
    oscola:
      "Стандартный стиль оформления юридических ссылок для юридических школ и журналов Великобритании",
    bluebook:
      "Основная система юридического цитирования для судов США и юридических журналов",
    aglc: "Стандартный стиль оформления юридических ссылок для юридических школ и судов Австралии",
    asa: "Стандартный стиль оформления для социологии и социальных исследований",
    apsa: "Стиль оформления для исследований и журналов по политологии",
    aaa: "Стандартный стиль оформления для антропологических исследований",
    nlm: "Стандарт оформления, используемый PubMed и National Library of Medicine",
    acm: "Стиль оформления для конференций ACM и исследований в области вычислительной техники",
    aps: "Стиль оформления для Physical Review и журналов APS",
    aip: "Стиль оформления для AIP и физических журналов",
    cell: "Стиль оформления для Cell Press и ведущих биологических журналов",
    science: "Стиль оформления для журнала Science и изданий AAAS",
    plos: "Стиль оформления для журналов открытого доступа PLOS",
    bmj: "Стиль оформления для BMJ и ведущих британских медицинских журналов",
    lancet: "Стиль оформления для семейства медицинских журналов The Lancet",
    jama: "Стиль оформления для JAMA и журналов сети JAMA Network",
    elsevierHarvard: "Вариант стиля Harvard, используемый в журналах Elsevier",
    springer: "Стиль оформления для журналов и книг Springer Nature",
  },

  // The 105 style-versus-style pages at `/<locale>/compare/<slug>`.
  //
  // The two style names arrive as placeholder values and are never translated. The
  // facts in the table come from `styleFacts` above and the taglines from
  // `styleTaglines`; only `fullName` stays in `src/data/style-pages.ts`, because an
  // official name is the same in every language.
  comparePage: {
    notFoundTitle: "Не найдено",
    metaTitle: "{a} vs {b}: ключевые различия [2026]",
    metaDescription:
      "Сравните стили оформления {a} и {b}. Узнайте о ключевых различиях в оформлении, ссылках в тексте и списках литературы, чтобы выбрать подходящий стиль для своей работы.",
    ogTitle: "{a} vs {b}",
    ogSubtitle:
      "Формат ссылок в тексте, оформление записей, использование заглавных букв и то, в каких дисциплинах требуется каждый из них.",
    ogKind: "Сравнение стилей",
    keywordVs: "{a} vs {b}",
    keywordVersus: "{a} против {b}",
    keywordDifference: "разница между {a} и {b}",
    keywordOr: "{a} или {b}",
    keywordComparison: "сравнение стилей оформления",
    breadcrumbCompare: "Сравнение стилей",
    breadcrumbCurrent: "{a} vs {b}",
    backLink: "← Назад к инструменту сравнения",
    heading: "{a} vs {b}: ключевые различия",
    intro:
      "{a} и {b} — два самых распространённых стиля оформления в академической среде, но между ними есть существенные различия. {introA} {introB} Понимание этих различий поможет выбрать правильный формат для вашей работы.",
    styleIntro: "{style} ({fullName}) {tagline}.",
    styleIntroFallback:
      "{style} — популярный стиль оформления, который используется во многих научных дисциплинах.",
    tableHeading: "Сравнение по пунктам",
    tableFeature: "Параметр",
    tableCitationSystem: "Система цитирования",
    tableInText: "Формат ссылок в тексте",
    tableReferenceList: "Название списка литературы",
    tableEdition: "Издание",
    tableCommonFields: "Общие дисциплины",
    // Title case, for the table cell. `styleLanding.system*` says "Author–date" for the
    // fact list on the style landing pages; both spellings are deliberate.
    systemAuthorDate: "Автор-дата",
    systemNumbered: "Числовая",
    systemFootnotes: "Сноски",
    // The same three systems inside a sentence ("uses a numbered citation system").
    describeAuthorDate: "автор-дата",
    describeNumbered: "числовая",
    describeFootnotes: "сноски",
    whenToUseHeading: "Когда использовать {style}",
    whenToUseBody:
      "{style} ({fullName}) использует систему цитирования «{system}»: ссылки в тексте — {inText}, а в конце работы — «{list}». Основные области применения: {fields}{more}.",
    whenToUseMoreFields: ", а также смежные области",
    whenToUseFallback:
      "{style} — широко признанный стиль оформления. Уточните в требованиях к заданию или в выбранном журнале, требуется ли формат {style}.",
    ctaHeading: "Посмотрите разницу на практике",
    ctaBodyBefore: "Попробуйте наш",
    ctaBodyLink: "интерактивный инструмент сравнения",
    ctaBodyAfter:
      "и сравните ссылки {a} и {b} бок о бок на примере ваших источников.",
    ctaCiteIn: "Оформить в {style} →",
    faqDifferenceQ: "В чём разница между {a} и {b}?",
    faqDifferenceA:
      "{a} и {b} отличаются форматом ссылок в тексте, структурой списка литературы и научными дисциплинами, которые их используют. {detail}",
    faqDifferenceDetail:
      "{a} использует ссылки в тексте вида {inTextA} и раздел «{listA}», а {b} — {inTextB} и раздел «{listB}».",
    faqDifferenceDetailFallback:
      "У каждого стиля свои правила оформления ссылок, построения списка литературы и работы с разными типами источников.",
    faqBetterQ: "Что лучше — {a} или {b}?",
    faqBetterA:
      "Ни {a}, ни {b} не являются однозначно лучше. Правильный выбор зависит от вашей научной дисциплины, требований преподавателя или журнала, в который вы подаёте материалы. Уточните требования к заданию или целевому изданию, чтобы определить нужный стиль.",
    faqSwitchQ: "Можно ли переключаться между {a} и {b}?",
    faqSwitchA:
      "Да, вы можете переключаться между {a} и {b}, используя бесплатный генератор ссылок CitationEasy. Просто выберите нужный стиль — и ссылки автоматически переоформятся. Однако в рамках одной работы обычно следует использовать только один стиль, если преподаватель не указал иное.",
  },

  // The ~21 converter-pair pages at `/<locale>/convert/<slug>`.
  //
  // Only the shell is here; each pair's own four strings are in `converterCopy` below.
  // The format names (DOI, ISBN, BibTeX, RIS, CSL-JSON, PubMed ID, arXiv ID, Word) are
  // identifiers, never translated.
  converterPage: {
    notFoundTitle: "Конвертер не найден",
    metaTitle: "{title} - бесплатно и мгновенно",
    ogTitle: "{title}",
    ogKind: "Конвертер",
    breadcrumbConverters: "Конвертеры",
    breadcrumbLabel: "Цепочка навигации",
    whenHeading: "Когда это нужно",
    relatedHeading: "Похожие конвертеры",
    allConverters: "Все конвертеры",
    formatConverterTool: "Конвертер форматов ссылок",
    faqHowQ: "Как преобразовать {input} в {output}?",
    faqHowA:
      "{intro} Всё бесплатно — без регистрации и без ограничений на число преобразований.",
    faqPrivacyQ: "Отправляются ли мои данные куда-либо?",
    faqPrivacyIdentifier:
      "Каждый идентификатор {input} проверяется через соответствующий открытый сервис метаданных (Crossref для DOI, PubMed для PMID, библиотечные каталоги для ISBN), и передаётся только сам идентификатор — никогда не ваши документы. Готовый результат можно скопировать или скачать; ничего не сохраняется.",
    faqPrivacyLocal:
      "Нет — {input}, который вы вставляете или загружаете, полностью обрабатывается в вашем браузере. {detail}",
    faqPrivacyDetailStyle:
      "Формировщику ссылок передаются только распознанные поля источника (автор, название, год) — сам файл никогда не покидает ваше устройство.",
    faqPrivacyDetailOffline:
      "Преобразование выполняется полностью офлайн, прямо на странице — ничего не отправляется на сервер.",
    faqUsefulQ: "Когда полезно преобразование {input} в {output}?",
    faqOtherQ: "Можно ли конвертировать и в другие стили и форматы?",
    faqOtherA:
      "Да. Генератор CitationEasy оформляет любой источник в {count} стилях, библиография экспортируется в Word, RTF, BibTeX, RIS и CSL-JSON, а на странице конвертеров перечислены все прямые пары преобразования. Если вам нужно переоформить уже готовый текст из одного стиля в другой, используйте инструмент «Конвертер форматов ссылок».",
  },

  // The 21 converter pairs' own copy (`CONVERTER_PAIRS` in src/data/converters.ts),
  // keyed by slug: title, meta description, the intro paragraph under the H1, and the
  // "when you need this" paragraph.
  //
  // Four hand-written strings per pair, and `src/data/converters.ts` has a quality rule
  // saying they must stay hand-written — no mail-merged sentences, because mass-templated
  // pages are what earned the site a scaled-content penalty. That rule is about how the
  // copy is authored; it says nothing about which language a reader gets it in. Left in
  // the data file they are the entire body of an otherwise translated page.
  // `converterPairCopy()` (src/lib/i18n/data-labels.ts) returns all four at once and
  // falls back to the data file per field, so a converter added upstream ships English
  // copy rather than a blank page.
  converterCopy: {
    doiToApaTitle: "Конвертер DOI в APA",
    doiToApaMetaDescription:
      "Вставьте DOI (по одному в строке) и мгновенно получите ссылки в стиле APA 7, сформированные по официальным метаданным Crossref издателя. Бесплатно, без регистрации.",
    doiToApaIntro:
      "DOI уже указывает на официальные метаданные издателя, поэтому вводить ссылку APA вручную незачем. Вставьте по одному DOI в строке — и каждый превратится в полную ссылку APA 7: авторы в инвертированном порядке, название с заглавной буквы только в начале, курсивное название журнала и обязательная для APA ссылка https://doi.org/.",
    doiToApaUseCase:
      "Типичная ситуация: преподаватель просит список литературы в APA, а у вас есть только набор DOI, накопленный во время чтения. Вставьте все разом — и скопируйте готовый список.",
    doiToMlaTitle: "Конвертер DOI в MLA",
    doiToMlaMetaDescription:
      "Автоматически превращайте DOI в записи списка цитируемых источников MLA 9 на основе метаданных Crossref. Вставьте по одному DOI в строке — бесплатно, ничего устанавливать не нужно.",
    doiToMlaIntro:
      "MLA 9 описывает журнальную статью как цепочку «контейнеров»: название статьи в кавычках, название журнала курсивом, том, номер выпуска, год, страницы — вручную собрать всё это без ошибок непросто. Поиск по DOI заполняет каждое поле по данным издателя, и запись в списке цитируемых источников получается правильной с первого раза.",
    doiToMlaUseCase:
      "Пригодится, если курс по гуманитарным наукам требует MLA, а источники найдены в естественнонаучных базах данных, которые выдают только DOI.",
    doiToBibtexTitle: "Конвертер DOI в BibTeX",
    doiToBibtexMetaDescription:
      "Преобразуйте DOI в записи BibTeX для LaTeX и Overleaf. Вставьте по одному DOI в строке и скачайте готовый файл .bib — бесплатно и без ограничений.",
    doiToBibtexIntro:
      "Рано или поздно любой статье в LaTeX понадобится файл .bib. Вставьте DOI по одному в строке — и получите аккуратные записи @article с автоматически сгенерированными ключами цитирования, готовые для Overleaf, natbib или biblatex: копировать поля со страниц издателя вручную не придётся.",
    doiToBibtexUseCase:
      "Классическая ситуация: рецензент присылает три статьи для цитирования, у вас есть их DOI, а дедлайн — сегодня вечером. Вставьте, скачайте файл и продолжайте писать \\cite.",
    doiToRisTitle: "Конвертер DOI в RIS",
    doiToRisMetaDescription:
      "Преобразуйте DOI в файл RIS, который напрямую импортируют Zotero, Mendeley и EndNote. Вставьте DOI по одному в строке — бесплатно, без регистрации.",
    doiToRisIntro:
      "RIS — формат обмена данными, который импортирует любой менеджер библиографии. Вставьте DOI и скачайте файл .ris, чьи поля TY/AU/TI/T2 взяты прямо из Crossref, — затем импортируйте его через «Файл → Импорт» в Zotero, Mendeley или EndNote, и записи появятся полностью структурированными.",
    doiToRisUseCase:
      "Идеально подходит для переноса вручную собранного списка DOI в полноценный менеджер библиографии без повторного набора имён авторов.",
    isbnToApaTitle: "Конвертер ISBN в APA",
    isbnToApaMetaDescription:
      "Автоматически превращайте ISBN в ссылки на книги в стиле APA 7. Вставьте по одному ISBN в строке и скопируйте готовый список — бесплатно, без регистрации.",
    isbnToApaIntro:
      "Для ссылки APA на книгу достаточно ISBN с титульного разворота. Каждый ISBN сверяется с библиотечными метаданными и оформляется по стандарту APA 7: автор, год, название курсивом и издательство, а также сведения об издании, если они есть в записи.",
    isbnToApaUseCase:
      "Самый быстрый способ оформить ссылки на стопку бумажных библиотечных книг: откройте титульный разворот каждой, перепишите ISBN и вставьте список сюда.",
    isbnToMlaTitle: "Конвертер ISBN в MLA",
    isbnToMlaMetaDescription:
      "Преобразуйте ISBN в записи списка цитируемых источников MLA 9 одной вставкой. Бесплатный поиск по ISBN с готовым результатом — регистрация не нужна.",
    isbnToMlaIntro:
      "Запись о книге в MLA 9 короткая: автор, название курсивом, издательство, год, — но инверсия имени автора и расстановка знаков препинания всё равно часто вызывают ошибки. Поиск по ISBN возвращает настоящую каталожную запись книги и оформляет её по шаблону основных элементов справочника MLA.",
    isbnToMlaUseCase:
      "Идеально для эссе по литературе: оформите ссылки на все романы и монографии на столе, введя только номера с задней обложки.",
    isbnToBibtexTitle: "Конвертер ISBN в BibTeX",
    isbnToBibtexMetaDescription:
      "Преобразуйте ISBN в записи @book формата BibTeX для LaTeX. Вставьте по одному ISBN в строке и скачайте файл .bib — бесплатно и мгновенно.",
    isbnToBibtexIntro:
      "Книги — неудобное место в BibTeX: DOI искать не по чему, а страницы издателей редко предлагают экспорт в .bib. Этот конвертер сверяет каждый ISBN с библиотечными метаданными и создаёт записи @book с уже заполненными полями автора, названия, издательства и года.",
    isbnToBibtexUseCase:
      "Для авторов дипломных и диссертационных работ: главы о методах ссылаются на DOI статей, а глава с теорией — на двенадцать книг. Этот инструмент берёт на себя как раз эти двенадцать книг.",
    pmidToApaTitle: "Конвертер PMID в APA",
    pmidToApaMetaDescription:
      "Автоматически преобразуйте идентификаторы PubMed (PMID) в ссылки APA 7. Вставьте PMID по одному в строке и получите готовый список литературы — бесплатно.",
    pmidToApaIntro:
      "У каждой записи PubMed есть PMID, а программы по психологии и сестринскому делу почти всегда требуют APA. Вставьте PMID по одному в строке — и каждый по метаданным самого PubMed превратится в полную журнальную ссылку APA 7, включая ссылку на DOI, если она есть в записи.",
    pmidToApaUseCase:
      "Создан для заданий по доказательной практике: поиск литературы заканчивается списком PMID, а работе нужны они в формате APA.",
    pmidToRisTitle: "Конвертер PMID в RIS",
    pmidToRisMetaDescription:
      "Превращайте идентификаторы PubMed (PMID) в файл RIS для Zotero, Mendeley или EndNote. Вставьте PMID по одному в строке и скачайте файл .ris — бесплатно.",
    pmidToRisIntro:
      "Работа над систематическими обзорами строится вокруг файлов RIS. Вставьте PMID из результатов поиска в PubMed и скачайте файл .ris, готовый для вашего инструмента скрининга или менеджера библиографии: каждая запись построена по официальным метаданным PubMed, а не по «выдернутому» из страницы тексту.",
    pmidToRisUseCase:
      "Полезно посреди работы над обзором, когда коллега присылает письмо «добавьте ещё эти пять исследований» с голыми PMID, а ваша библиотека живёт в EndNote.",
    arxivToBibtexTitle: "Конвертер arXiv в BibTeX",
    arxivToBibtexMetaDescription:
      "Преобразуйте идентификаторы arXiv в записи BibTeX для статей в LaTeX. Вставьте идентификаторы вида 2301.12345 по одному в строке и скачайте файл .bib — бесплатно.",
    arxivToBibtexIntro:
      "В быстро развивающихся областях препринты цитируют постоянно, а идентификаторы arXiv (вроде 2301.12345) — это то, как они циркулируют. Вставьте идентификаторы — и получите записи BibTeX с авторами, названием, годом и ссылкой на препринт arXiv, готовые для файла .bib вашей статьи.",
    arxivToBibtexUseCase:
      "Для авторов статей по машинному обучению и физике, у которых раздел «связанные работы» на 80% состоит из arXiv: собирайте идентификаторы во время чтения, а конвертируйте всё разом при написании текста.",
    bibtexToApaTitle: "Конвертер BibTeX в APA",
    bibtexToApaMetaDescription:
      "Вставьте текст или загрузите файл .bib — и получите список литературы в APA 7. Обрабатывает файлы с несколькими записями — бесплатно, разбор происходит прямо в браузере.",
    bibtexToApaIntro:
      "Иногда статье приходится покинуть LaTeX: журнал просит подать материал в Word, а комиссия хочет получить список литературы обычным текстом. Вставьте BibTeX (или загрузите файл .bib) — каждая запись разбирается прямо в браузере и оформляется как список литературы APA 7, который можно вставить в любой документ.",
    bibtexToApaUseCase:
      "Специально для заявок на гранты: список публикаций хранится в файле .bib, а форма фонда требует ссылки в формате APA прямо в текстовом поле.",
    bibtexToMlaTitle: "Конвертер BibTeX в MLA",
    bibtexToMlaMetaDescription:
      "Преобразуйте BibTeX в записи списка цитируемых источников MLA 9. Вставьте текст или загрузите файл .bib и скопируйте готовый список — бесплатно, без регистрации.",
    bibtexToMlaIntro:
      "BibTeX хранит поля в сыром виде, а MLA точно определяет порядок их расстановки. Этот конвертер разбирает записи .bib локально и оформляет каждую по шаблону MLA 9: инверсия имени автора, название статьи в кавычках, курсивные «контейнеры» и правильная пунктуация между элементами.",
    bibtexToMlaUseCase:
      "Для авторов на стыке дисциплин: ссылки хранятся в BibTeX со времён работы в LaTeX, а гуманитарный журнал, куда вы подаёте статью, требует MLA.",
    bibtexToRisTitle: "Конвертер BibTeX в RIS",
    bibtexToRisMetaDescription:
      "Преобразуйте файл .bib в RIS для Zotero, Mendeley или EndNote. Вставьте текст или загрузите BibTeX и скачайте файл .ris — бесплатно и полностью офлайн.",
    bibtexToRisIntro:
      "Переход от инструментов LaTeX к менеджеру библиографии означает перевод записей @article/@book из BibTeX в теги TY/AU/TI формата RIS. Преобразование целиком выполняется в браузере, включая сопоставление полей, и выдаёт файл .ris, который импортирует любой менеджер.",
    bibtexToRisUseCase:
      "Типичный повод: новый соавтор работает в Zotero, общие ссылки хранятся в виде .bib в репозитории, и кому-то нужно навести мост между ними.",
    bibtexToCslJsonTitle: "Конвертер BibTeX в CSL-JSON",
    bibtexToCslJsonMetaDescription:
      "Преобразуйте BibTeX в CSL-JSON для Pandoc и Quarto. Вставьте текст или загрузите файл .bib и скачайте references.json — бесплатно, прямо в браузере.",
    bibtexToCslJsonIntro:
      "Pandoc и Quarto изначально цитируют из CSL-JSON, и преобразование имеющегося файла .bib убирает лишнее звено из сборки. Записи разбираются в браузере и превращаются в аккуратный массив CSL-JSON — именно в том виде, который ожидает параметр --bibliography=references.json.",
    bibtexToCslJsonUseCase:
      "Для тех, кто пишет в первую очередь на Markdown и переносит старый проект из LaTeX в Quarto: перенесите библиографию, не редактируя JSON вручную.",
    bibtexToWordTitle: "Конвертер BibTeX в Word",
    bibtexToWordMetaDescription:
      "Превратите файл .bib в документ Word со списком литературы в формате APA и висячим отступом. Бесплатно — разбор происходит прямо в браузере.",
    bibtexToWordIntro:
      "Когда файлу .bib нужно стать документом, а не очередным форматом данных, этот конвертер локально разбирает BibTeX, оформляет каждую запись по APA 7 и выдаёт файл Word с уже отсортированным по алфавиту списком литературы и висячим отступом.",
    bibtexToWordUseCase:
      "Финальный шаг в цепочке: журнал принял статью, но просит итоговый список литературы в виде редактируемого файла Word, а ваш источник истины — BibTeX.",
    risToApaTitle: "Конвертер RIS в APA",
    risToApaMetaDescription:
      "Вставьте текст или загрузите экспорт RIS — и получите список литературы в APA 7. Работает с экспортом из Zotero, Mendeley, EndNote и научных баз данных — бесплатно.",
    risToApaIntro:
      "Кнопка «Экспорт» в любой базе данных выдаёт RIS, а задание требует APA. Вставьте экспортированный текст (или загрузите файл .ris) — и каждая запись TY/AU/TI разбирается в браузере и оформляется как ссылка APA 7, без установки менеджера библиографии.",
    risToApaUseCase:
      "Короткий путь из библиотечной базы данных: экспортируйте результаты поиска в RIS, преобразуйте их здесь — и не тратьте время на настройку Zotero ради одной работы.",
    risToMlaTitle: "Конвертер RIS в MLA",
    risToMlaMetaDescription:
      "Преобразуйте экспорт RIS из баз данных или менеджеров библиографии в записи списка цитируемых источников MLA 9. Вставьте текст или загрузите файл — бесплатно, без регистрации.",
    risToMlaIntro:
      "JSTOR, ProQuest и EBSCO — все экспортируют в RIS, а кафедры английского языка все хотят MLA. Эта страница закрывает разрыв между ними: записи разбираются локально и оформляются по шаблону основных элементов MLA 9, готовые для вставки на страницу цитируемых источников.",
    risToMlaUseCase:
      "Создано для ночи перед сдачей эссе: десять источников экспортированы из JSTOR в файл citations.ris, а желания оформлять их вручную — ноль.",
    risToBibtexTitle: "Конвертер RIS в BibTeX",
    risToBibtexMetaDescription:
      "Преобразуйте RIS в BibTeX для LaTeX и Overleaf. Вставьте текст или загрузите экспортированный файл .ris и скачайте чистый файл .bib — бесплатно, прямо в браузере.",
    risToBibtexIntro:
      "Движение в сторону LaTeX: менеджеры библиографии и базы данных «говорят» на RIS, а сборке статьи нужен .bib. Записи преобразуются целиком в браузере — типы сопоставляются по тегам TY, генерируются ключи цитирования — в файл, который Overleaf принимает как есть.",
    risToBibtexUseCase:
      "Часто встречается в совместной работе: пользователь Zotero экспортирует RIS, пользователь LaTeX прогоняет его через эту страницу — и оба остаются при своих инструментах.",
    risToCslJsonTitle: "Конвертер RIS в CSL-JSON",
    risToCslJsonMetaDescription:
      "Преобразуйте экспорт RIS в CSL-JSON для конвейеров Pandoc и Quarto. Вставьте текст или загрузите файл .ris и скачайте references.json — бесплатно.",
    risToCslJsonIntro:
      "Для пользователей Pandoc и Quarto CSL-JSON — родной формат библиографии. Передайте странице RIS, экспортированный вашей базой данных или менеджером, и получите структурированный массив JSON: каждая запись разбирается локально, ничего никуда не отправляется.",
    risToCslJsonUseCase:
      "Встраивается в процессы «документация как код»: рецензенты присылают вложения RIS, файл ссылок в репозитории — references.json, а эта страница служит переходником между ними.",
    cslJsonToBibtexTitle: "Конвертер CSL-JSON в BibTeX",
    cslJsonToBibtexMetaDescription:
      "Преобразуйте CSL-JSON (экспорт из Pandoc, Quarto или Zotero) в BibTeX. Вставьте текст или загрузите файл .json и скачайте файл .bib — бесплатно, прямо в браузере.",
    cslJsonToBibtexIntro:
      "Иногда процесс идёт в обратную сторону: библиография, рождённая в конвейере Pandoc или Zotero, должна попасть в сборку LaTeX. Этот конвертер читает массив CSL-JSON в браузере и создаёт записи BibTeX, сопоставляя типы и поля обратно из модели CSL.",
    cslJsonToBibtexUseCase:
      "Для автора в Quarto, чей соавтор настаивает на Overleaf: держите references.json как основной источник и генерируйте .bib по мере необходимости.",
    cslJsonToRisTitle: "Конвертер CSL-JSON в RIS",
    cslJsonToRisMetaDescription:
      "Преобразуйте CSL-JSON в RIS, чтобы Zotero, Mendeley или EndNote могли его импортировать. Вставьте текст или загрузите файл .json и скачайте файл .ris — бесплатно.",
    cslJsonToRisIntro:
      "CSL-JSON прекрасно работает внутри конвейеров Pandoc, но остаётся «непрозрачным» для диалогов импорта большинства менеджеров библиографии. Преобразование в RIS делает те же записи универсально импортируемыми: каждая запись сопоставляется с тегами TY/AU/TI прямо в браузере, ничего не отправляется на сервер.",
    cslJsonToRisUseCase:
      "Проблема передачи: библиография хранится как references.json в git-репозитории, а научный руководитель просит «сделать в EndNote» к пятнице.",
  },

  // The infinite-scroll style list shared by the country and subject pages and by the
  // /citation-styles hub. It is a client component, so these arrive as a prop rather
  // than through `getDictionary` — pulling all 17 dictionaries into the browser bundle
  // to label a search box is the thing `link-path.ts` exists to avoid.
  stylesBrowser: {
    defaultTitle: "Все стили оформления",
    styleSingular: "стиль",
    stylePlural: "стилей",
    found: "найдено",
    filterPlaceholder: "Фильтр стилей…",
    noMatches: "По вашему запросу ничего не найдено.",
    loadingMore: "Загружаем ещё стили…",
    loadMore: "Загрузить ещё ({count} осталось)",
    showingAll: "Показаны все {count} стилей",
    internationalLabel: "Международный",
  },

  footer: {
    tagline:
      "Бесплатный генератор ссылок с {count} стилями. Без аккаунта, без платной подписки и без ограничений.",
    freeTools: "Бесплатные инструменты",
    resources: "Материалы",
    legal: "Правовая информация",
    language: "Язык",
    languageLabel: "Выберите язык",
    rights:
      "Ссылки оформляются по официальным описаниям Citation Style Language.",
    popularStyles: "Популярные стили",
    about: "О проекте",
    privacy: "Конфиденциальность",
    terms: "Условия",
    contact: "Контакты",
    copyright: "© {year} CitationEasy. Бесплатно.",
    poweredBy: "Работает на",
    allTools: "Все инструменты для письма",
    citationGuides: "Руководства по оформлению",
    allStyles: "Все стили оформления",
    citationGlossary: "Словарь терминов",
    howToCiteAny: "Как оформить любой источник",
  },

  faq: {
    heading: "Частые вопросы",
    homeQ1: "CitationEasy действительно бесплатный?",
    homeA1:
      "Да. CitationEasy полностью бесплатен: без регистрации, без ограничений и без платной версии. Все {count} стилей оформления доступны каждому.",
    homeQ2: "Какие стили оформления поддерживаются?",
    homeA2:
      "Все {count} стилей из проекта Citation Style Language, включая APA 7-е издание, MLA 9-е издание, Chicago, Harvard, Vancouver, IEEE, AMA и Turabian.",
    homeQ3: "Нужен ли аккаунт?",
    homeA3:
      "Нет. CitationEasy работает целиком в браузере, а список литературы хранится на вашем устройстве. Ничего не загружается на сервер, и регистрироваться негде.",
    homeQ4: "Можно ли оформлять ссылки на своём языке?",
    homeA4:
      "Да. Язык оформления ссылок — отдельная настройка, не связанная с языком сайта, поэтому можно работать по-русски, а ссылки получать на языке вашей работы.",
    styleQ1: "Генератор ссылок {style} бесплатный?",
    styleA1:
      "Да. Оформление ссылок в стиле {style} бесплатно и без ограничений, аккаунт не нужен. Вставьте DOI, URL, ISBN или запись BibTeX и скопируйте готовую ссылку.",
    styleQ2: "Как оформить источник в стиле {style}?",
    styleA2:
      "Вставьте DOI, URL, ISBN или запись BibTeX источника в генератор на этой странице. Стиль {style} уже выбран, поэтому ссылка и внутритекстовая отсылка появляются сразу.",
    styleQ3: "Насколько точно оформление {style}?",
    styleA3:
      "Каждая ссылка строится по официальному описанию стиля {style} из проекта Citation Style Language — тому же файлу, который используют Zotero и Mendeley, — а не по приблизительному пересказу правил.",
  },

  tool: {
    modeLabel: "Способ ввода источника",
    modeAuto: "URL / DOI / ISBN",
    modeBook: "Поиск книг",
    modeArticles: "Поиск статей",
    modeManual: "Ручной ввод",
    errorEnterManually: "Ввести данные вручную",
    autoLabel: "Вставьте URL, DOI, PMID, идентификатор arXiv, ISBN или BibTeX",
    autoHint:
      "Мы автоматически определим тип и загрузим метаданные. Вставьте по одному идентификатору в строке, чтобы оформить сразу весь список.",
    generate: "Создать ссылку",
    generating: "Создание…",
    bookSearchLabel: "Поиск по названию, автору или ISBN",
    bookSearchEmpty:
      "Результатов пока нет. Нажмите «Найти», чтобы найти книги.",
    bookSearchSource: "Ищет в каталоге Open Library — миллионы книг",
    worksSearchLabel: "Поиск по названию статьи или авторам",
    worksSearchEmpty:
      "Результатов пока нет. Нажмите «Найти», чтобы найти статьи.",
    worksSearchSource:
      "Ищет в каталоге Crossref: журнальные статьи, доклады конференций и главы книг",
    showingResults: "Показано {shown} из {total} результатов",
    search: "Найти",
    searching: "Поиск…",
    bulkResults: "Результаты пакетного оформления",
    copy: "Копировать",
    copied: "Скопировано!",
    copyHint: "Скопируйте и вставьте в свою работу",
    resultTitle: "Оформленная ссылка",
    edit: "Изменить",
    completeFields: "Дополнить",
    fieldsIncomplete:
      "one:{count} поле не заполнено|few:{count} поля не заполнены|many:{count} полей не заполнено|other:{count} поля не заполнено",
    outputLanguage: "Язык",
    sourceType: "Тип источника",
    fieldAuthors: "Автор(ы)",
    fieldAuthorsHint: "Иванов, Иван или Иван Иванов",
    fieldTitle: "Название статьи или книги",
    fieldBookTitle: "Название книги",
    fieldBookTitleHint: "Название книги или сборника",
    fieldEditors: "Редактор(ы)",
    fieldJournal: "Журнал / издание",
    fieldJournalHint: "Название журнала или издания",
    fieldPublisher: "Издательство / сайт",
    fieldPublisherHint: "Название издательства или сайта",
    fieldDate: "Дата / год",
    fieldVolume: "Том",
    fieldIssue: "Выпуск",
    fieldPages: "Страница(ы)",
    fieldFormat: "Формат / носитель",
    fieldAuthorsGroup: "Коллективный автор или организация",
    fieldAuthorsGroupHint:
      "Чтобы указать организацию вместе с людьми, заключите её в фигурные скобки: {R Core Team}, Иван Иванов",
    fieldTranslators: "Переводчик(и)",
    fieldInterviewers: "Интервьюер(ы)",
    fieldVersion: "Версия",
    fieldCourt: "Суд",
    fieldIssuingAuthority: "Выдавший орган",
    fieldPatentNumber: "Номер патента",
    fieldEpisodeNumber: "Номер эпизода",
    fieldLawNumber: "Номер закона или законопроекта",
    fieldReportNumber: "Номер отчёта",
    fieldReviewedTitle: "Название рецензируемой работы",
    fieldReviewedAuthors: "Автор(ы) рецензируемой работы",
    inTextCitation: "Ссылка в тексте",
    quickEdit: "Быстрое изменение",
    quickEditHint: "Обновите метаданные и создайте ссылку заново.",
    update: "Обновить",
    saving: "Сохранение…",
    fieldAuthor: "Автор",
    fieldDateShort: "Дата",
    fieldTitleShort: "Название",
  },

  toolCollections: {
    "citation-generators": "Генераторы цитат",
    "citation-tools": "Инструменты для цитирования и списков литературы",
    "paper-formatting": "Оформление работ",
    "essay-writing": "Написание эссе и работ",
    "writing-analysis": "Анализ и редактирование текста",
    "word-counters": "Счётчики и удобочитаемость",
    vocabulary: "Словарный запас и поиск слов",
    "research-tools": "Исследования и публикации",
    statistics: "Статистические калькуляторы",
    math: "Математические калькуляторы",
    science: "Калькуляторы для естественных наук и лаборатории",
    charts: "Графики и диаграммы",
    economics: "Экономика, бизнес и финансы",
    grades: "Калькуляторы GPA и оценок",
    study: "Учёба и продуктивность",
    classroom: "Для класса и печати",
    random: "Случайные генераторы и жеребьёвка",
    "text-tools": "Очистка и форматирование текста",
    "fancy-text": "Декоративный текст и символы",
    language: "Языки и транслитерация",
    ciphers: "Коды и шифры",
    converters: "Конвертеры единиц, дат и чисел",
    developer: "Данные, разметка и код",
  },
  bib: {
    title: "Мои списки литературы",
    studioTitle: "Студия библиографии",
    studioProjects: "Проекты",
    studioExplore: "Обзор",
    studioExploreIntro:
      "Руководства, инструменты и все стили цитирования — в один клик.",
    studioStyleGuide: "Руководство по стилю {style}",
    studioStyleGuideHint:
      "Правила, разобранные примеры и формат внутритекстовой ссылки",
    studioGenerator: "Генератор ссылок",
    studioNewProject: "Новый проект",
    studioSwitchProject: "Сменить проект",
    studioAddSource: "Добавить источник",
    studioAddSourceHint:
      "Вставьте DOI, URL или ISBN, найдите книгу или статью либо введите данные вручную. Всё, что вы сохраняете, попадает в этот проект.",
    studioDoneAdding: "Готово",
    studioReferences: "Источники",
    studioReferenceCount: "Источников: {count}",
    studioInspectorTitle: "Сведения об источнике",
    studioInspectorEmpty:
      "Выберите источник, чтобы увидеть внутритекстовую ссылку, заметки и сведения о нём.",
    studioSavedLocally: "Сохранено в этом браузере",
    studioOpen: "Открыть Студию библиографии",
    studioViewInStudio: "Открыть в Студии",
    studioFooterSaved: "В Студии библиографии сохранено: {count}",
    studioFooterEmpty:
      "Сохранённые ссылки складываются в полную библиографию в Студии",
    studioClearSelection: "Снять выделение",
    studioDeleteSelected: "Удалить выбранные",
    studioDeleteSelectedBody:
      "Удалить {count} ссылок из «{name}»? Это действие нельзя отменить.",
    studioDeletedMany: "Удалено ссылок: {count}",
    studioMoveTo: "Переместить в",
    studioCopyTo: "Скопировать в",
    studioSearchShortcut: "Нажмите /, чтобы искать",
    studioStyle: "Стиль",
    studioCopyEntry: "Скопировать запись",
    studioEntryCopied: "Запись скопирована",
    studioSourceDetails: "Сведения об источнике",
    studioEmptyTitle: "Этот проект пуст",
    studioEmptyBody:
      "Добавьте первый источник выше или импортируйте библиотеку BibTeX, RIS или CSL-JSON.",
    studioBackup: "Резервная копия",
    sharedTitle: "Общий список литературы",
    save: "Сохранить",
    saving: "Сохранение…",
    saved: "Сохранено",
    searchPlaceholder: "Поиск по ссылкам…",
    empty: "Пока нет сохранённых ссылок",
    emptySearch: "Ничего не найдено по вашему запросу.",
    countIn: "Ссылок в «{name}»: {count}",
    savedOn: "Сохранено {date}",
    emptyInBib:
      "В этом списке литературы пока нет ссылок. Создайте и сохраните ссылки или импортируйте библиотеку BibTeX, RIS либо CSL-JSON.",
    savedToast: "Ссылка сохранена в список литературы",
    copyAll: "Копировать все",
    copyAllTitle: "Копировать все ссылки",
    export: "Экспорт",
    exportTitle: "Экспортировать список литературы",
    import: "Импорт",
    importTitle: "Импортировать источники",
    importLabel: "Импортировать источники (BibTeX, RIS или CSL-JSON)",
    importing: "Импорт…",
    importFailed: "Не удалось импортировать. Попробуйте ещё раз.",
    importSummary:
      "Импортировано: {added} · Дубликатов пропущено: {duplicates} · Сверх лимита: {overLimit} · Ошибок: {failed}",
    importUnreadable: "Не удалось прочитать файл.",
    importUnparseable: "Не удалось импортировать источники.",
    importReviewTitle: "Проверка импорта",
    importReviewIntro:
      "Проверьте {total} источников {format} перед форматированием и сохранением.",
    importReviewCount: "Включено {included} из {total}",
    importSelectAll: "Включить все",
    importExcludeAll: "Исключить все",
    importLimitNotice:
      "{count} источников сверх лимита в 200 записей не будут импортированы.",
    importDuplicateExisting:
      "Возможный дубликат сохранённого источника «{title}»",
    importDuplicateBatch: "Возможный дубликат «{title}» в этом импорте",
    importMissingField: "Отсутствует поле «{field}»",
    importUntitled: "Источник без названия",
    importReview: "Проверить источники",
    importCommit: "Форматировать и импортировать",
    importBack: "Назад",
    importOutcomeTitle: "Импорт завершён",
    importOutcomeSummary:
      "Добавлено: {added} · Дубликаты пропущены: {duplicates} · Исключено: {excluded} · Сверх лимита: {overLimit} · Ошибки: {failed}",
    sortBy: "Сортировать по",
    sortTitle: "Сортировать список литературы",
    sortAuthor: "Автор (А–Я)",
    sortNewest: "Дате добавления (сначала новые)",
    sortOldest: "Году (сначала старые)",
    sortManual: "Ручной порядок",
    backupAll: "Полная резервная копия проектов (.json)",
    backupDownloaded: "Полная резервная копия загружена",
    backupUnreadable: "Не удалось прочитать файл резервной копии.",
    restore: "Восстановить",
    restoreTitle: "Восстановить все проекты библиографий",
    restoreWarning:
      "Сначала резервная копия будет проверена, затем она заменит все библиографии, сохранённые в этом браузере. Это действие нельзя отменить.",
    restoreChoose: "Выберите резервную копию CitationEasy (.json)",
    replaceAndRestore: "Заменить и восстановить",
    restoreComplete: "Все проекты библиографий восстановлены",
    restoreInvalid: "Это недопустимая резервная копия проекта CitationEasy.",
    selectAllVisible: "Выбрать всё показанное",
    selectedCount: "Выбрано: {count}",
    clusterOpen: "Цитировать вместе",
    clusterTitle: "Составная внутритекстовая ссылка",
    clusterDescription:
      "Создайте единый кластер ссылок из выбранных источников. Выбранный стиль определяет порядок, пунктуацию и нумерацию.",
    clusterTarget: "Результат",
    clusterLocatorOptional: "Необязательный локатор",
    clusterBuildCopy: "Создать и скопировать ссылку",
    clusterBuilding: "Создание ссылки…",
    clusterCopied: "Составная ссылка скопирована",
    clusterFailed: "Не удалось создать составную ссылку. Повторите попытку.",
    destination: "Целевая библиография",
    chooseDestination: "Выберите библиографию…",
    copySelected: "Копировать",
    moveSelected: "Переместить",
    copyComplete:
      "Скопировано цитат: {count}. Пропущено дубликатов: {skipped}.",
    moveComplete:
      "Перемещено цитат: {count}. Дубликатов осталось в источнике: {skipped}.",
    selectCitation: "Выбрать {title}",
    moveUp: "Переместить вверх",
    moveDown: "Переместить вниз",
    deleteTitle: "Удалить ссылку",
    deleteConfirm: "Удалить ссылку?",
    deleted: "Ссылка удалена",
    editTitle: "Изменить ссылку",
    close: "Закрыть",
    copiedAll: "Все ссылки скопированы!",
    copiedAnnotated: "Аннотированный список скопирован!",
    copiedBibtex: "BibTeX скопирован!",
    copiedBulleted: "Маркированный список скопирован!",
    copiedNumbered: "Нумерованный список скопирован!",
    copiedHtml: "Фрагмент HTML скопирован!",
    downloadedWord: "Документ Word загружен",
    downloadedRtf: "Файл RTF загружен",
    downloadedRis: "Файл RIS загружен",
    downloadedCsl: "Файл CSL-JSON загружен",
    downloadedAnnotated: "Аннотированный список загружен",
    copyFailed: "Не удалось скопировать в буфер обмена",
    shareCopied:
      "Ссылка скопирована! Любой, у кого она есть, может открыть и импортировать этот список.",
    shareFailed: "Не удалось создать ссылку для доступа",
    regenerateFailed: "Не удалось создать ссылку заново",
    updateFailed: "Не удалось обновить ссылку",
    fieldAuthor: "Автор",
    fieldTitle: "Название",
    fieldDate: "Дата",
    fieldPublisher: "Издательство",
    fieldVolume: "Том",
    fieldIssue: "Выпуск",
    fieldPages: "Страница(ы)",
    fieldUrl: "URL",
    fieldAccessed: "Дата обращения",
    fieldEditor: "Редактор",
    fieldEvent: "Место проведения",
    noteLabel: "Аннотация к этому источнику",
    noteEdit: "Изменить эту заметку",
    notePlaceholder:
      "Кратко изложите источник, оцените его и укажите, как он связан с вашей работой…",
    noteRemoved: "Заметка удалена",
    noteSave: "Сохранить заметку",
    noteCancel: "Отмена",
    noteAdd: "Добавить заметку",
    noteWords: "слов: {count}",
    noteSaved: "Заметка сохранена (слов: {count})",
    noteClickToEdit: "нажмите, чтобы изменить",
    inTextCopy: "Скопировать внутритекстовую ссылку на этот источник",
    inTextSelect: "Выделите ссылку ниже, чтобы скопировать её.",
    inTextFailed:
      "Не удалось построить внутритекстовую ссылку. Попробуйте ещё раз.",
    locator: "Указание места",
    locatorType: "Тип указания",
    locatorPage: "Страница",
    locatorChapter: "Глава",
    locatorSection: "Раздел",
    locatorParagraph: "Абзац",
    locatorLine: "Строка",
    locatorVerse: "Стих",
    reformat: "Переформатировать",
    reformatTitle: "Переформатировать все ссылки в другом стиле",
    reformatHeading: "Переформатировать всё в одном стиле",
    reformatChoose: "Выберите стиль…",
    reformatFailed:
      "Переформатировать не удалось. Список литературы не изменён.",
    sortOrder: "Критерий сортировки",
    copyToClipboard: "Копировать в буфер обмена",
    numberedList: "Нумерованный список",
    bulletedList: "Маркированный список",
    htmlSnippet: "Фрагмент HTML",
    copyWithAnnotations: "Копировать с аннотациями",
    wordAnnotated: "Документ Word с аннотациями (.doc)",
    downloadFile: "Скачать файл",
    wordDocument: "Документ Word (.doc)",
    copyShareLink: "Копировать ссылку для доступа",
    print: "Печать…",
    printFailed: "Всплывающее окно заблокировано — разрешите его для печати",
    font: "Шрифт",
    sitePublication: "Сайт / название издания",
    importIntro:
      "Вставьте или загрузите файл BibTeX (.bib), RIS (.ris) либо CSL-JSON (.json)",
    importUpload: "Загрузите файл .bib, .ris или .json",
    importPaste: "Или вставьте BibTeX, RIS либо CSL-JSON",
    cancel: "Отмена",
    done: "Готово",
    delete: "Удалить",
    deleteBody:
      "Ссылка будет безвозвратно удалена из вашего списка литературы.",
    editBody: "Обновите метаданные и сохраните, чтобы создать ссылку заново.",
    reformatExplain:
      "Пересобирает все записи ({count}) из сохранённых данных источника — ничего не загружается повторно и ни один источник не теряется.",
    inTextHeading: "Ссылка в тексте",
    inTextLocatorHint:
      "Добавьте страницу или другое указание места, чтобы привязать ссылку к фрагменту источника — при прямом цитировании этого требует большинство стилей. Оставьте пустым для простой формы.",
    inTextCopyButton: "Копировать внутритекстовую ссылку",
    mixedStyles:
      "В этом списке литературы смешаны стили оформления: {count} ({styles}).",
    mixedStylesAction:
      "Нажмите {action}, чтобы привести всё к одному стилю перед сдачей работы.",
    selectBibliography: "Выбрать список литературы",
    newBibliography: "Новый список литературы",
    moreOptions: "Другие действия",
    rename: "Переименовать",
    removeDuplicates: "Удалить дубликаты",
    cannotDeleteOnly: "Нельзя удалить единственный список литературы",
    newBibliographyBody:
      "Создайте список литературы для другой работы или проекта.",
    bibliographyName: "Название списка литературы",
    create: "Создать",
    renameBibliography: "Переименовать список литературы",
    renameBibliographyBody: "Введите новое название для «{name}».",
    newName: "Новое название",
    duplicateRemovedOne: "Удалён {count} дубликат",
    duplicateRemovedMany: "Удалено дубликатов: {count}",
    noDuplicates: "Дубликаты источников не найдены",
    removeDuplicatesConfirm: "Удалить повторяющиеся источники?",
    removeDuplicatesBody:
      "В «{name}» будут найдены одинаковые источники (по DOI, ISBN или названию, году и автору) и сохранено по одной копии. Несопоставимые источники останутся без изменений.",
    deleteBibliographyConfirm: "Удалить список литературы?",
    deleteBibliographyBody:
      "«{name}» и все цитирования ({count}) будут удалены безвозвратно.",
  },

  bibliographyPage: {
    metaTitle: "Студия библиографии - систематизация, аннотации и экспорт",
    metaDescription:
      "Создавайте частные библиографические проекты в браузере. Ищите, сортируйте, аннотируйте, редактируйте, форматируйте, импортируйте и экспортируйте без аккаунта.",
    keyword1: "создание библиографии",
    keyword2: "менеджер цитирований",
    keyword3: "аннотированная библиография",
    ogTitle: "Студия библиографии",
    ogDescription:
      "Частное рабочее пространство для организации, форматирования, аннотирования, импорта и экспорта источников.",
    ogImageTitle: "Студия библиографии",
    ogImageSubtitle:
      "Организуйте, аннотируйте, форматируйте, экспортируйте и делитесь источниками.",
    ogKind: "Рабочее пространство",
    breadcrumb: "Студия библиографии",
    eyebrow: "Частное пространство в браузере",
    lead: "Управляйте всеми источниками работы в одном месте. Проекты остаются в этом браузере, пока вы сами не экспортируете или не поделитесь ими.",
    privacyTitle: "Конфиденциально по умолчанию",
    privacyBody:
      "Проекты и аннотации хранятся локально в браузере. Ссылки содержат цитирования, но намеренно исключают личные заметки.",
    workflowTitle: "От списка источников к готовой работе",
    workflowBody:
      "Переключайте проекты, ищите и сортируйте источники, добавляйте аннотации или локаторы, исправляйте метаданные и форматируйте весь список единообразно.",
    formatsTitle: "Импортируйте и переносите источники",
    formatsBody:
      "Импортируйте BibTeX, RIS или CSL-JSON. Копируйте готовые списки или экспортируйте Word, RTF, RIS, CSL-JSON, HTML, BibTeX и версии с аннотациями.",
  },

  // The 95-term glossary: /glossary and /glossary/[slug].
  //
  // The chrome only. Each term's own prose — `short`, the `body` paragraphs, the
  // example — is ~10,600 words that cannot live in a flat string map and must not be
  // copied verbatim into sixteen files; it lives in `src/content/glossary/<locale>.json`
  // and is read through `lib/localized-content.ts`.
  glossaryPage: {
    metaTitle: "{term} - определение и примеры",
    notFoundTitle: "Термин не найден",
    keywordDefinition: "определение термина {term}",
    keywordWhatIs: "что такое {term}",
    ogTitle: "{term} - глоссарий CitationEasy",
    ogKind: "Глоссарий терминов оформления",
    breadcrumb: "Глоссарий",
    alsoCalled: "Также называется: {aliases}",
    doItHeading: "Сделайте это в CitationEasy",
    seeAlsoHeading: "См. также",
    moreInHeading: "Больше в разделе «{category}»",
    navLabel: "Навигация по глоссарию",
    allTermsLink: "Все {count} терминов глоссария",
    generatorLink: "Бесплатный генератор ссылок",
    termSetName: "Глоссарий терминов оформления CitationEasy",
    hubMetaTitle:
      "Глоссарий терминов оформления - {count} терминов с объяснениями",
    hubMetaDescription:
      "Простые определения {count} терминов оформления ссылок и академического письма: et al., ibid., DOI, висячий отступ, лоскутное письмо, окончательная версия и многое другое — с примерами для каждого.",
    hubKeyword1: "глоссарий терминов оформления",
    hubKeyword2: "термины оформления ссылок",
    hubKeyword3: "глоссарий академического письма",
    hubKeyword4: "что значит et al",
    hubKeyword5: "что такое DOI",
    hubKeyword6: "терминология оформления ссылок",
    hubOgTitle: "Глоссарий терминов оформления",
    hubOgDescription:
      "Определения {count} терминов оформления ссылок и академического письма с примерами.",
    hubOgImageTitle: "Глоссарий терминов оформления",
    hubOgImageSubtitle:
      "{count} терминов оформления ссылок и академического письма с простыми определениями и примерами.",
    hubOgKind: "Справочник",
    hubTermSetDescription:
      "Определения {count} терминов оформления ссылок, цитирования и академического письма.",
    hubCollectionName: "Глоссарий терминов оформления",
    hubCollectionDescription:
      "Простые определения {count} терминов оформления ссылок и академического письма.",
    hubHeading: "Глоссарий терминов оформления",
    hubIntro:
      "{count} терминов из сферы оформления ссылок и академического письма с простыми определениями и примерами — сокращения из стилевых руководств, составные части ссылки, идентификаторы, точно определяющие источник, и словарь научных публикаций.",
    hubJumpLabel: "Перейти к букве",
    hubBrowseHeading: "Обзор по темам",
    hubAllHeading: "Все термины от А до Я",
    hubWorkHeading: "Примените термины на практике",
    hubWorkGenerator: "Бесплатный генератор ссылок",
    hubWorkStyles: "Руководства по стилям оформления",
    hubWorkHowTo: "Как процитировать любой источник",
    hubWorkCompare: "Сравнить стили оформления",
    hubWorkTools: "Инструменты для письма и оформления ссылок",
    hubWorkFaq: "Вопросы об оформлении ссылок",
  },

  // /faq — the 17-question hub. The questions and answers themselves are in
  // `src/data/faq.ts` (the one source the API, the MCP tool and /md also read); this is
  // the page around them.
  faqPage: {
    metaTitle:
      "Вопросы об оформлении ссылок - быстрые ответы на частые вопросы",
    metaDescription:
      "Быстрые и точные ответы на вопросы об оформлении ссылок, которые реально задают студенты: DOI, источники без автора, et al., висячий отступ, цитирование ИИ, правила о плагиате, APA против MLA и многое другое — со ссылками на полные руководства.",
    ogTitle: "Вопросы об оформлении ссылок",
    ogDescription:
      "Быстрые ответы на самые частые вопросы об оформлении ссылок — от DOI и et al. до цитирования ChatGPT.",
    ogImageTitle: "Вопросы и ответы об оформлении ссылок",
    ogImageSubtitle:
      "Короткие точные ответы на вопросы, которые студенты реально задают об оформлении ссылок.",
    ogKind: "FAQ",
    breadcrumbLabel: "Цепочка навигации",
    breadcrumbHome: "Главная",
    breadcrumbCurrent: "Вопросы об оформлении ссылок",
    heading: "Вопросы об оформлении ссылок",
    intro:
      "Быстрые и точные ответы на вопросы об оформлении ссылок, которые реально задают студенты — со ссылками на полное руководство или инструмент, если нужно углубиться.",
    contentsLabel: "Содержание раздела вопросов",
    stillStuckHeading: "Всё ещё не разобрались?",
    stillStuckBody:
      "Загляните в [полную библиотеку руководств](/guides), проверьте [шпаргалки по стилям](/cheat-sheets), найдите нужный термин в [глоссарии терминов оформления](/glossary), [выполните поиск по всему сайту](/search) или просто [создайте ссылку](/) — и форматирование возьмёт на себя генератор.",
  },

  // /cheat-sheets and its three style sheets. The citation FORMATS in them
  // ("Author, A. A. (Year)…") are the styles' own templates and stay as they are in
  // every language, exactly as the per-style examples do; the labels around them do not.
  cheatSheets: {
    hubMetaTitle: "Шпаргалки по стилям оформления - краткие справочники",
    hubMetaDescription:
      "Краткие справочные шпаргалки по стилям APA, MLA и Chicago. Удобные для печати руководства с примерами распространённых типов источников.",
    hubBreadcrumbHome: "Главная",
    hubBreadcrumbCurrent: "Шпаргалки по стилям оформления",
    hubBackLink: "← Назад к генератору",
    hubHeading: "Шпаргалки по стилям оформления",
    hubIntro:
      "Краткие справочники по самым популярным стилям оформления. Удобны для печати и всегда актуальны.",
    hubApaTitle: "Шпаргалка по APA 7-го издания",
    hubApaDesc: "Психология, социальные науки, педагогика, сестринское дело",
    hubMlaTitle: "Шпаргалка по MLA 9-го издания",
    hubMlaDesc: "Литература, языки, гуманитарные науки, культурология",
    hubChicagoTitle: "Шпаргалка по стилю Chicago",
    hubChicagoDesc: "История, история искусства, философия, религия",
    backToSheets: "← Назад к шпаргалкам",
    generalRules: "Общие правила",
    inTextCitations: "Ссылки в тексте",
    colSituation: "Ситуация",
    colFormat: "Формат",
    colExample: "Пример",
    book: "Книга",
    journalArticle: "Журнальная статья",
    website: "Веб-сайт",
    apaMetaTitle: "Шпаргалка по APA 7-го издания - краткий справочник",
    apaMetaDescription:
      "Шпаргалка по оформлению в стиле APA 7-го издания с примерами для книг, журналов, веб-сайтов и других источников. Удобный для печати краткий справочник.",
    apaHeading: "Шпаргалка по APA 7-го издания",
    apaLead:
      "Краткий справочник по самым распространённым форматам оформления APA.",
    apaRule1:
      'Используйте **висячий отступ** (первая строка без отступа, последующие — с отступом 0,5" (1,27 см))',
    apaRule2: "Используйте двойной межстрочный интервал для всех записей",
    apaRule3: "Располагайте по алфавиту фамилий авторов",
    apaRule4: "Выделяйте курсивом названия книг, журналов и томов",
    apaRule5: "Указывайте DOI, если он доступен",
    apaRow1Situation: "1 автор",
    apaRow1Format: "(Author, Year)",
    apaRow1Example: "(Smith, 2024)",
    apaRow2Situation: "2 автора",
    apaRow2Format: "(Author & Author, Year)",
    apaRow2Example: "(Smith & Jones, 2024)",
    apaRow3Situation: "3 и более авторов",
    apaRow3Format: "(First Author et al., Year)",
    apaRow3Example: "(Smith et al., 2024)",
    apaRow4Situation: "Прямая цитата",
    apaRow4Format: "(Author, Year, p. #)",
    apaRow4Example: "(Smith, 2024, p. 45)",
    apaRow5Situation: "Нет автора",
    apaRow5Format: '("Title," Year)',
    apaRow5Example: '("Study Results," 2024)',
    apaReferenceHeading: "Примеры списка литературы",
    apaBookExample:
      "Author, A. A. (Year). *Title of work: Capital letter also for subtitle*. Publisher. https://doi.org/xxxxx",
    apaJournalExample:
      "Author, A. A., & Author, B. B. (Year). Title of article. *Title of Periodical, Volume*(Issue), Page–Page. https://doi.org/xxxxx",
    apaWebsiteExample:
      "Author, A. A. (Year, Month Day). *Title of page*. Site Name. https://www.example.com/page",
    apaChapterLabel: "Глава в книге под редакцией",
    apaChapterExample:
      "Author, A. A. (Year). Title of chapter. In E. E. Editor (Ed.), *Title of book* (pp. #–#). Publisher.",
    apaConferenceLabel: "Доклад конференции",
    apaConferenceExample:
      "Author, A. A. (Year, Month Days). *Title of paper* [Paper presentation]. Conference Name, Location.",
    apaDifferencesHeading: "Основные отличия от APA 6-го издания",
    apaDifference1: "Перед URL больше не пишется «Retrieved from»",
    apaDifference2: "DOI указывается в формате ссылки https://doi.org/",
    apaDifference3:
      "Перечисляется до 20 авторов, прежде чем использовать многоточие",
    apaDifference4: "Место издания больше не требуется",
    apaDifference5:
      "Используйте местоимение «they» в единственном числе для гендерно-нейтрального языка",
    apaCtaText: "Создавайте безупречные ссылки APA автоматически",
    apaCtaButton: "Генератор ссылок APA →",
    mlaMetaTitle: "Шпаргалка по MLA 9-го издания - краткий справочник",
    mlaMetaDescription:
      "Шпаргалка по оформлению в стиле MLA 9-го издания с примерами для книг, статей, веб-сайтов и других источников. Удобный для печати краткий справочник.",
    mlaHeading: "Шпаргалка по MLA 9-го издания",
    mlaLead:
      "Краткий справочник по самым распространённым форматам оформления MLA.",
    mlaRule1: "Используйте **висячий отступ**",
    mlaRule2: "Используйте двойной межстрочный интервал для всех записей",
    mlaRule3: "Располагайте по алфавиту фамилий авторов",
    mlaRule4: "Озаглавьте страницу «Список использованных источников»",
    mlaRule5:
      "Выделяйте курсивом названия контейнеров (книг, журналов, веб-сайтов)",
    mlaRow1Situation: "1 автор",
    mlaRow1Format: "(Author Page)",
    mlaRow1Example: "(Smith 45)",
    mlaRow2Situation: "2 автора",
    mlaRow2Format: "(Author and Author Page)",
    mlaRow2Example: "(Smith and Jones 45)",
    mlaRow3Situation: "3 и более авторов",
    mlaRow3Format: "(First Author et al. Page)",
    mlaRow3Example: "(Smith et al. 45)",
    mlaRow4Situation: "Нет автора",
    mlaRow4Format: '("Title" Page)',
    mlaRow4Example: '("Study Results" 45)',
    mlaRow5Situation: "Нет номера страницы",
    mlaRow5Format: "(Author)",
    mlaRow5Example: "(Smith)",
    mlaWorksCitedHeading: "Примеры списка использованных источников",
    mlaBookExample: "Last, First. *Title of Book*. Publisher, Year.",
    mlaJournalExample:
      'Last, First. "Title of Article." *Journal Title*, vol. #, no. #, Year, pp. #–#.',
    mlaWebsiteExample:
      'Last, First. "Title of Page." *Website Name*, Day Month Year, URL.',
    mlaAnthologyLabel: "Антология / книга под редакцией",
    mlaAnthologyExample:
      'Last, First. "Title of Essay." *Title of Collection*, edited by First Last, Publisher, Year, pp. #–#.',
    mlaCoreHeading: "Основные элементы MLA (по порядку)",
    mlaCore1: "Author.",
    mlaCore2: '"Title of Source."',
    mlaCore3: "*Title of Container*,",
    mlaCore4: "Contributors,",
    mlaCore5: "Version,",
    mlaCore6: "Number,",
    mlaCore7: "Publisher,",
    mlaCore8: "Publication date,",
    mlaCore9: "Location (pages, URL, DOI).",
    mlaCtaText: "Создавайте безупречные ссылки MLA автоматически",
    mlaCtaButton: "Генератор ссылок MLA →",
    chicagoMetaTitle: "Шпаргалка по стилю Chicago - краткий справочник",
    chicagoMetaDescription:
      "Шпаргалка по стилю Chicago Manual of Style с примерами систем «Примечания — библиография» и «Автор — дата». Удобный для печати краткий справочник.",
    chicagoHeading: "Шпаргалка по стилю Chicago",
    chicagoLead:
      "Краткий справочник по форматам оформления Chicago Manual of Style (18-е издание).",
    chicagoSystemsHeading: "Две системы Chicago",
    chicagoColNb: "Примечания — библиография (NB)",
    chicagoColAd: "Автор — дата (AD)",
    chicagoRow1Nb: "Сноски/концевые примечания + библиография",
    chicagoRow1Ad: "Ссылки в скобках + список литературы",
    chicagoRow2Nb: "История, искусство, гуманитарные науки",
    chicagoRow2Ad: "Естественные и социальные науки",
    chicagoRow3Nb: "Более подробные первые примечания",
    chicagoRow3Ad: "Похож на формат APA",
    chicagoExamplesHeading: "Примеры системы «Примечания — библиография»",
    chicagoNoteLabel: "Примечание:",
    chicagoBibliographyLabel: "Библиография:",
    chicagoBookLabel: "Книга (сноска)",
    chicagoBookNote: "1. First Last, *Title of Book* (Publisher, Year), page.",
    chicagoBookBibliography: "Last, First. *Title of Book*. Publisher, Year.",
    chicagoJournalLabel: "Журнальная статья (сноска)",
    chicagoJournalNote:
      '1. First Last, "Title of Article," *Journal Title* Vol, no. Issue (Year): pages.',
    chicagoJournalBibliography:
      'Last, First. "Title of Article." *Journal Title* Vol, no. Issue (Year): pages.',
    chicagoWebsiteLabel: "Веб-сайт (сноска)",
    chicagoWebsiteNote:
      '1. First Last, "Title of Page," Site Name, Month Day, Year, URL.',
    chicagoWebsiteBibliography:
      'Last, First. "Title of Page." Site Name. Month Day, Year. URL.',
    chicagoShortHeading: "Сокращённые примечания",
    chicagoShortIntro:
      "После первой полной ссылки используйте сокращённые сноски:",
    chicagoShortExample: "1. Last, *Short Title*, page.",
    chicagoRulesHeading: "Основные правила оформления",
    chicagoRule1:
      "Используйте надстрочные номера для ссылок на сноски в тексте",
    chicagoRule2: "Записи в библиографии оформляются с висячим отступом",
    chicagoRule3:
      "Для последовательных ссылок на один и тот же источник используйте сокращённую сноску вместо «Ibid.»",
    chicagoRule4:
      "Названия: книги и журналы — курсивом, статьи и главы — в кавычках",
    chicagoRule5:
      "Указывайте дату обращения для онлайн-источников, которые могут измениться",
    chicagoCtaText: "Создавайте безупречные ссылки Chicago автоматически",
    chicagoCtaButton: "Генератор ссылок Chicago →",
  },

  // The catalog's page-type labels (`CATALOG_TYPE_LABELS`), which the search page shows
  // as facet chips and beside every result. Layer 2: a fact from `src/lib/**` rather
  // than page chrome, and English until it is mapped through here.
  catalogTypes: {
    core: "Основные страницы",
    styleLanding: "Разделы основных стилей оформления",
    style: "Справочные страницы стилей оформления",
    styleExamples: "Страницы примеров оформления",
    styleFormat: "Руководства по оформлению работ",
    styleInText: "Руководства по ссылкам в тексте",
    styleAnnotatedBibliography: "Руководства по аннотированной библиографии",
    styleReferencePage:
      "Руководства по списку литературы и списку использованных источников",
    tool: "Бесплатные инструменты для письма и оформления ссылок",
    guide: "Обучающие руководства",
    guideCategory: "Категории руководств",
    toolCollection: "Подборки инструментов",
    howToCite: "Как процитировать <источник> в <стиле>",
    comparison: "Сравнения стилей оформления",
    converter: "Конвертеры идентификаторов и форматов",
    field: "Стили оформления по научной области",
    region: "Стили оформления по стране/региону",
    category: "Стили оформления по предметной категории",
    cheatSheet: "Шпаргалки на одну страницу",
    glossary: "Глоссарий терминов оформления и академического письма",
  },

  // /about
  aboutPage: {
    metaTitle: "О CitationEasy - бесплатный генератор ссылок",
    metaDescription:
      "CitationEasy — бесплатный генератор ссылок, поддерживающий {count} стилей. Создан Сэмюэлом Серджи (Samuel Sergi) с использованием инструментов с открытым исходным кодом: Citation Style Language, Citation.js и Next.js.",
    backLink: "← Назад к генератору",
    heading: "О CitationEasy",
    intro:
      "CitationEasy — бесплатный генератор ссылок с открытым доступом для студентов, исследователей и авторов академических текстов. Он поддерживает **{count} стилей оформления** и предлагает растущую коллекцию инструментов для письма, обучающих руководств и справочных материалов — и всё это без регистрации и подписки.",
    offerHeading: "Что мы предлагаем",
    offer1:
      "[Генератор ссылок](/) с {count} стилями, включая APA 7-е издание, MLA 9-е издание, Chicago 18-е издание, Harvard, Vancouver, IEEE и тысячи других",
    offer2:
      "[40 бесплатных инструментов для письма и оформления ссылок](/tools) — счётчик слов, проверка удобочитаемости, валидатор DOI, сортировщик библиографии по алфавиту и другое",
    offer3:
      "[750 руководств «как процитировать»](/how-to-cite), охватывающих все основные типы источников в 6 стилях оформления",
    offer4:
      "[100+ обучающих руководств](/guides) о правилах оформления ссылок, академическом письме и исследовательских навыках",
    offer5:
      "[Инструмент сравнения стилей](/compare), [тест на подбор стиля оформления](/quiz) и [шпаргалки](/cheat-sheets) для быстрого справочника",
    offer6:
      "7 форматов экспорта: обычный текст, BibTeX, Word, нумерованный список, маркированный список, RIS и CSV",
    openSourceHeading: "Создано с открытым исходным кодом",
    openSourceIntro:
      "CitationEasy стал возможен благодаря ряду отличных проектов и API с открытым исходным кодом. Мы считаем важным указывать источники:",
    openSource1:
      "[Citation Style Language (CSL)](https://citationstyles.org/) — открытый стандарт, на котором работают наши {count} стилей оформления. CSL поддерживается сообществом волонтёров и используется менеджерами ссылок, такими как Zotero, Mendeley и Papers. Описания стилей берутся из [репозитория стилей CSL](https://github.com/citation-style-language/styles) на GitHub.",
    openSource2:
      "[Citation.js](https://citation.js.org/) — библиотека JavaScript, которая обрабатывает ссылки и форматирует их согласно стилям CSL. Создана Ларсом Виллигагеном (Lars Willighagen).",
    openSource3:
      "[Open Library API](https://openlibrary.org/developers/api) — бесплатный API поиска книг от Internet Archive, используется для поиска метаданных книг по названию или ISBN.",
    openSource4:
      "[DOI Foundation](https://www.doi.org/) — система цифровых идентификаторов объектов (DOI), используемая для разрешения и проверки DOI.",
    createdHeading: "Автор",
    createdBody:
      "CitationEasy создан и поддерживается **Samuel Sergi**. Цель проста: предоставить действительно бесплатный, качественный инструмент для оформления ссылок, который не прячет функции за платным доступом и не требует регистрации.",
    contactPrompt: "Есть вопросы, отзывы или предложения? Свяжитесь с нами:",
    contactEmail: "Email: [sam@sammysergi.com](mailto:sam@sammysergi.com)",
    missionHeading: "Наша миссия",
    mission1:
      "Точные ссылки не должны стоить денег. Многие инструменты для оформления ссылок рекламируются как бесплатные, но ограничивают форматы экспорта, число ссылок или подталкивают пользователей к платным тарифам. CitationEasy стремится оставаться полностью бесплатным — без регистрации, без ограничений, без платного тарифа.",
    mission2:
      "Каждая функция на этом сайте — от генератора ссылок до инструментов для письма и обучающих руководств — доступна всем бесплатно. Мы считаем, что инструменты академической добросовестности должны быть доступны всем студентам и исследователям, независимо от их бюджета.",
  },

  // /contact
  contactPage: {
    metaTitle: "Свяжитесь с нами",
    metaDescription:
      "Свяжитесь с командой CitationEasy. Вопросы, отзывы или предложения о нашем бесплатном генераторе ссылок и инструментах для письма? Будем рады вас услышать.",
    backLink: "← Назад к генератору",
    heading: "Свяжитесь с нами",
    intro:
      "Есть вопросы, отзывы или предложения о CitationEasy? Будем рады вас услышать. Нашли ошибку, хотите предложить новую функцию или вам нужна помощь с оформлением ссылки — не стесняйтесь обращаться.",
    touchHeading: "Как с нами связаться",
    touchBody:
      "Лучший способ связаться с нами — по электронной почте. Мы стараемся отвечать в течение 48 часов.",
    emailLine: "**Email:** [sam@sammysergi.com](mailto:sam@sammysergi.com)",
    commonHeading: "Частые вопросы",
    commonIntro:
      "Прежде чем писать нам, вы можете найти ответ на свой вопрос в одном из этих материалов:",
    resource1:
      "[Руководства по оформлению ссылок](/guides) — пошаговые инструкции по оформлению источников в каждом основном стиле",
    resource2:
      "[Руководства «как процитировать»](/how-to-cite) — 750 комбинаций типов источников и стилей с примерами",
    resource3:
      "[Шпаргалки](/cheat-sheets) — быстрый справочник по оформлению APA, MLA и Chicago",
    resource4:
      "[Инструменты для письма](/tools) — счётчик слов, проверка удобочитаемости, валидатор DOI и другое",
    issueHeading: "Сообщить о проблеме",
    issueIntro:
      "Если вы обнаружили ошибку в оформлении ссылки, неработающую функцию или неверный стиль, пожалуйста, укажите как можно больше подробностей при обращении к нам:",
    issue1: "Стиль оформления, которым вы пользовались",
    issue2: "Тип источника (книга, веб-сайт, журнальная статья и т. д.)",
    issue3: "Что вы ожидали получить и что было создано на самом деле",
    issue4: "Ваш браузер и устройство (если это важно)",
    issueOutro: "Это поможет нам быстро найти и устранить проблему.",
    aboutHeading: "О CitationEasy",
    aboutBody:
      "CitationEasy — бесплатный генератор ссылок, поддерживающий более 10 000 стилей оформления. Он создан Samuel Sergi с целью сделать точные ссылки доступными для всех. Узнайте больше на нашей [странице «О нас»](/about).",
  },

  // /ai — the agent and developer docs.
  //
  // The code samples, endpoint paths and MCP tool NAMES are deliberately absent: they are
  // the API's identifiers, served in English by the API itself, and a translated one
  // would document an endpoint that does not exist.
  aiPage: {
    metaTitle:
      "CitationEasy для ИИ-ассистентов и агентов - API, сервер MCP, llms.txt",
    metaDescription:
      "Используйте CitationEasy программно: бесплатный JSON API без авторизации для оформления ссылок в {count} стилях, сервер MCP для агентов, llms.txt, спецификация OpenAPI и markdown-версии всех страниц.",
    keyword1: "API для оформления ссылок",
    keyword2: "сервер MCP",
    keyword3: "API генератора ссылок",
    keyword4: "llms.txt",
    keyword5: "OpenAPI",
    keyword6: "ссылки для ИИ-агентов",
    keyword7: "бесплатный API для оформления ссылок",
    webApiDescription:
      "Бесплатный JSON API без авторизации, который оформляет ссылки в {count} стилях Citation Style Language по URL, DOI, ISBN, PubMed ID, arXiv ID или метаданным CSL-JSON.",
    breadcrumb: "Для ИИ и агентов",
    heading: "CitationEasy для ИИ-ассистентов и агентов",
    intro:
      "Всё на этом сайте доступно не только людям, но и программам: бесплатный JSON API, сервер MCP, спецификация OpenAPI, индекс llms.txt и markdown-версии всех {count} страниц. Без ключа, без аккаунта, без собственных ограничений скорости запросов.",
    whyHeading:
      "Почему стоит вызывать API, а не составлять ссылку самостоятельно",
    whyBody:
      "Оформление ссылок выглядит как задача генерации текста, но таковой не является. Каждый стиль кодирует сотни правил об инверсии имени автора, инициалах, регистре заголовков, пунктуации контейнера, указании издания и расположении даты, и эти правила отличаются настолько, что легко ошибиться, полагаясь на память. CitationEasy запускает **citeproc-js** на основе официальных описаний Citation Style Language — того же движка, что использует Zotero и Mendeley, — поэтому результат детерминирован и соответствует ожиданиям систем подачи материалов в журналы. Метаданные берутся из Crossref, Open Library и PubMed; ничего не придумывается, а поле, отсутствующее в источнике, остаётся отсутствующим, а не заполняется правдоподобной догадкой.",
    generateHeading: "Создать ссылку",
    generateBody:
      "Отправьте `inputs` вместо `input`, чтобы обработать до 10 источников за один вызов, либо `entry` с уже имеющимися у вас метаданными CSL-JSON, чтобы полностью пропустить поиск. Добавьте `note: true` для формы сноски. Ошибки по отдельным источникам возвращаются для конкретного источника, поэтому пакетный запрос никогда не завершается ошибкой целиком.",
    mcpHeading: "Подключение через MCP",
    mcpIntro:
      "Конечная точка Model Context Protocol по адресу `/api/mcp` использует JSON-RPC 2.0 поверх потокового HTTP и не требует учётных данных.",
    mcpToolsHeading: "Инструменты, которые она предоставляет",
    endpointsHeading: "Конечные точки",
    colEndpoint: "Конечная точка",
    colWhat: "Что она делает",
    endpointCite:
      "Форматирует до 10 источников одновременно. Принимает URL, DOI, ISBN, PubMed ID, arXiv ID, текст BibTeX/RIS/CSL-JSON или объект записи CSL-JSON. Возвращает запись для списка литературы и, по желанию, ссылку в тексте и сноску.",
    endpointStyles:
      "Поиск по всем {count} стилям по названию, классу формата оформления, дисциплине или региону.",
    endpointStyleSlug:
      "Один стиль полностью, с реальными оформленными примерами, созданными по его собственному описанию CSL.",
    endpointSearch: "Поиск по релевантности по всем страницам сайта.",
    endpointPages:
      "Полный каталог сайта в виде структурированных записей с фильтрацией по типу страницы.",
    endpointHowToCite:
      "Каждая страница «источник × стиль» с фильтрацией по любому из них.",
    endpointTools:
      "Каждый бесплатный инструмент с его категорией и ключевыми словами.",
    endpointGuides: "Каждое обучающее руководство с его категорией.",
    endpointConverters:
      "Все конвертеры идентификаторов и форматов, доступные на сайте.",
    endpointComparisons:
      "Сравнения стилей бок о бок, связанные с записями обоих стилей.",
    endpointFields:
      "Научные области, предметные категории и регионы — для ответа на вопрос «какой стиль мне использовать?».",
    endpointFaq:
      "Проверенные ответы на частые вопросы об оформлении ссылок с фильтрацией по q.",
    endpointGlossary:
      "Термины оформления ссылок и академического письма с полными определениями — ответ содержит сам текст, поэтому дополнительно загружать страницу не нужно.",
    endpointIndex:
      "Документ обнаружения конечных точек. Начните отсюда, если вы изучаете API.",
    discoveryHeading: "Файлы обнаружения",
    discoveryLlms: "Курируемый индекс сайта, написанный для языковых моделей.",
    discoveryLlmsFull:
      "Каждая страница, которую публикует сайт, сгруппированная по типу, по одной строке на страницу.",
    discoveryOpenapi: "Описание OpenAPI 3.1 всего публичного API.",
    discoveryMcp:
      "Конечная точка MCP (потоковый HTTP). Выполните GET в браузере, чтобы увидеть описание.",
    discoveryWellKnownMcp:
      "Документ обнаружения MCP для агентов, которые проверяют домен.",
    discoveryAiPlugin:
      "Устаревший манифест плагина для фреймворков, которые всё ещё его ищут.",
    discoveryMd: "Markdown-версия любой страницы сайта.",
    discoverySitemap: "Каждый индексируемый URL.",
    catalogHeading: "Что входит в каталог",
    catalogIntro:
      "Каждая страница ниже доступна как HTML, как markdown под `/md/` и как структурированная запись из `/api/v1/pages`.",
    catalogStyles:
      "**{count}** стилей оформления, каждый с реальными примерами, созданными по его собственному описанию CSL",
    catalogTools: "**{count}** бесплатных браузерных инструментов",
    catalogGuides: "**{count}** обучающих руководств",
    catalogHowToCite: "**{count}** страниц «как процитировать»",
    catalogComparisons: "**{count}** сравнений стилей",
    catalogConverters: "**{count}** конвертеров",
    catalogFields: "**{count}** научных областей",
    catalogStyleLandings:
      "**{count}** разделов основных стилей с полными правилами оформления",
    faqHeading: "Часто задаваемые вопросы",
    faqFreeQ: "Бесплатен ли API CitationEasy, и нужен ли мне ключ API?",
    faqFreeA:
      "Он бесплатен, и ключ API не требуется. Каждая конечная точка под /api/v1 не требует авторизации и открыта для CORS, поэтому вы можете вызывать её из браузера, ноутбука или агента без регистрации. У нас нет собственных ограничений скорости запросов, но поиск по идентификаторам проксируется в Crossref, Open Library и PubMed, которые применяют собственные ограничения добросовестного использования — используйте пакетную обработку через `inputs` вместо множества параллельных запросов.",
    faqLlmQ: "Создаются ли ссылки языковой моделью?",
    faqLlmA:
      "Нет. Форматирование выполняет citeproc-js на основе официальных описаний Citation Style Language — того же движка, что используют менеджеры ссылок. Одни и те же входные данные и стиль всегда дают одну и ту же строку. Библиографические метаданные берутся из Crossref (DOI), Open Library (ISBN) и PubMed (PMID) — CitationEasy не придумывает поля, поэтому всё отсутствующее в источнике отсутствует и в результате, а не угадывается.",
    faqMcpQ: "Как подключить агента к CitationEasy через MCP?",
    faqMcpA:
      "Укажите любому клиенту Model Context Protocol адрес https://www.citationeasy.com/api/mcp, используя потоковый HTTP-транспорт. Учётные данные не требуются. В Claude Code: `claude mcp add --transport http citationeasy https://www.citationeasy.com/api/mcp`. Сервер предоставляет инструменты для создания ссылок, поиска по {count} стилям, рекомендаций по типам источников, поиска по сайту и чтения любой страницы в формате markdown.",
    faqStylesQ: "Какие стили оформления может создавать API?",
    faqStylesA:
      'Все {count} стилей из репозитория Citation Style Language, включая APA 7, MLA 9, обе системы Chicago, Harvard, Vancouver, IEEE, AMA и тысячи отдельных журнальных стилей. Передайте слаг стиля в поле `style`. Удобные слаги вроде "chicago" и "harvard" разрешаются в правильный вариант CSL, а /api/v1/styles?q= находит остальные.',
    faqLlmsTxtQ: "Что такое llms.txt и где найти его у CitationEasy?",
    faqLlmsTxtA:
      "llms.txt — это текстовый индекс сайта, написанный для языковых моделей, а не для браузеров. У CitationEasy он находится по адресу /llms.txt; исчерпывающая версия со списком всех страниц сайта — по адресу /llms-full.txt.",
    faqMarkdownQ:
      "Могу ли я читать страницы CitationEasy в формате markdown вместо HTML?",
    faqMarkdownA:
      "Да. Добавьте префикс /md/ к любому пути сайта — например, /md/citation-style/apa или /md/tools/word-counter. Страницы, основанные на данных, возвращают полное содержимое, включая реальные оформленные примеры, созданные по собственному описанию CSL каждого стиля. Страницы с рукописным текстом (руководства, шпаргалки) возвращают карточку с кратким содержанием и каноническим URL HTML-страницы, поскольку их текст существует только на самой странице.",
    faqReuseQ:
      "Могу ли я использовать результат CitationEasy в своём продукте?",
    faqReuseA:
      "Да. Оформленная ссылка — это факт об источнике, используйте её свободно. Сами описания стилей CSL взяты из проекта Citation Style Language по лицензии CC BY-SA 3.0. Указание CitationEasy в качестве источника приветствуется, но не обязательно.",
    missingHeading: "Чего-то не хватает?",
    missingBody:
      "Если вашему агенту нужна конечная точка, поле или формат, которых здесь нет, [сообщите нам](/contact). Просматриваете вручную? [Начните с генератора ссылок](/).",
  },

  // /quiz. The client component reads these as a prop rather than through a context:
  // it is one component, not the generator's nine, so there is nothing to drill through.
  quizPage: {
    metaTitle:
      "Какой стиль оформления мне использовать? - бесплатный тест на подбор стиля",
    metaDescription:
      "Ответьте на несколько коротких вопросов о вашей области, типе работы и предпочтениях, чтобы найти лучший стиль оформления для вашей работы. APA, MLA, Chicago, Vancouver и другие.",
    ogTitle: "Какой стиль оформления мне использовать?",
    ogDescription:
      "Пройдите наш бесплатный тест, чтобы найти лучший стиль оформления для вашей работы.",
    breadcrumbHome: "CitationEasy",
    breadcrumbCurrent: "Тест на стиль",
    backLink: "← Назад к генератору",
    heading: "Какой стиль оформления мне использовать?",
    intro:
      "Ответьте на несколько коротких вопросов, и мы порекомендуем лучший стиль оформления для вашей работы.",
    progress: "Вопрос {current} из {total}",
    qDiscipline: "Какая у вас область изучения?",
    optSocialScience: "Психология / социальные науки",
    optHumanities: "Литература / гуманитарные науки",
    optHistory: "История / история искусства",
    optMedical: "Медицина / сестринское дело / здравоохранение",
    optEngineering: "Инженерия / информатика",
    optNaturalScience: "Естественные науки (биология, химия)",
    optLaw: "Право",
    optBusiness: "Бизнес / экономика",
    qPaperType: "Какую работу вы пишете?",
    optResearch: "Научная работа или диссертация",
    optReview: "Обзор литературы",
    optReport: "Лабораторный или технический отчёт",
    optEssay: "Эссе или учебное задание",
    optJournal: "Статья для подачи в журнал",
    qRegion: "Где находится ваше учебное заведение?",
    optUs: "США",
    optUk: "Великобритания / Австралия",
    optCanada: "Канада",
    optEurope: "Европа (кроме Великобритании)",
    optOther: "Другое",
    qPreference: "Есть ли у вас предпочтения по формату ссылок?",
    optAuthorDate: "Ссылки в тексте (Автор, Год)",
    optNumeric: "Нумерованные ссылки [1]",
    optFootnotes: "Сноски",
    optNoPreference: "Нет предпочтений",
    styleVancouver: "Vancouver",
    styleAma: "AMA (Американская медицинская ассоциация)",
    styleIeee: "IEEE",
    styleBluebook: "Bluebook",
    styleCse: "CSE (Совет редакторов научных изданий)",
    styleChicagoNotes: "Chicago (примечания и библиография)",
    styleMla: "MLA (9-е издание)",
    styleApa: "APA (7-е издание)",
    styleHarvard: "Harvard",
    reasonVancouverMedical:
      "Vancouver — стандарт для медицинских журналов и журналов по здравоохранению, использующий нумерованные ссылки.",
    reasonAma:
      "AMA широко используется в медицинских журналах и использует нумерованные ссылки.",
    reasonIeee:
      "IEEE — стандартный стиль оформления для инженерии, информатики и IT-сферы.",
    reasonBluebook:
      "Bluebook — основной стиль оформления для юридических текстов. Chicago — ближайшая универсальная альтернатива.",
    reasonCse: "CSE — стандарт для биологии и естественных наук.",
    reasonChicagoHistory:
      "Chicago (примечания и библиография) — золотой стандарт для истории и истории искусства, использующий сноски для ссылок.",
    reasonChicagoHumanities:
      "Chicago (примечания и библиография) хорошо подходит для гуманитарных наук благодаря подходу на основе сносок.",
    reasonMla: "MLA — стандарт для литературы, языков и гуманитарных наук.",
    reasonApaBusiness:
      "APA широко используется в бизнесе, экономике и менеджменте.",
    reasonHarvard:
      "Harvard — самый распространённый стиль в университетах Великобритании и Австралии.",
    reasonChicagoFootnotes:
      "Chicago (примечания и библиография) использует сноски, идеально подходящие для подробных ссылок.",
    reasonVancouverNumeric:
      "Vancouver использует нумерованные ссылки, делая ваш текст чистым и удобочитаемым.",
    reasonApaDefault:
      "APA — самый широко используемый стиль оформления в социальных науках, образовании и многих других дисциплинах.",
    recommendLabel: "Мы рекомендуем",
    generateButton: "Создать ссылки {style}",
    retakeButton: "Пройти тест снова",
    guidesLink:
      "Посмотрите наши руководства по оформлению для дополнительной помощи →",
    previousButton: "← Предыдущий вопрос",
  },

  // /search — the server-rendered site search.
  searchPage: {
    metaTitle: "Поиск по CitationEasy",
    metaDescription:
      "Ищите сразу по всем страницам CitationEasy: {count} стилей оформления, более 250 бесплатных инструментов, руководства, страницы «как процитировать», сравнения стилей, конвертеры и глоссарий.",
    keyword1: "поиск стилей оформления",
    keyword2: "найти руководство по оформлению",
    keyword3: "поиск инструментов оформления",
    ogDescription:
      "Ищите сразу по всем страницам сайта — стили, инструменты, руководства, страницы «как процитировать», сравнения, конвертеры и термины глоссария.",
    ogImageSubtitle:
      "Все стили оформления, инструменты, руководства, страницы «как процитировать», сравнения, конвертеры и термины глоссария — единый поиск.",
    ogKind: "Поиск",
    breadcrumb: "Поиск",
    heading: "Поиск по CitationEasy",
    intro:
      "Все стили оформления, инструменты, руководства, страницы «как процитировать», сравнения, конвертеры и термины глоссария на сайте — единый поиск.",
    inputLabel: "Поисковый запрос",
    inputPlaceholder:
      "например: процитировать подкаст в APA, висячий отступ, DOI",
    submit: "Найти",
    browseHeading: "Или посмотрите по разделам",
    browseStyles: "Стили оформления",
    browseStylesNote: "{count} стилей",
    browseTools: "Бесплатные инструменты",
    browseToolsNote: "{count} инструментов",
    browseHowTo: "Как процитировать любой источник",
    browseHowToNote: "{count} страниц",
    browseGuides: "Руководства",
    browseGuidesNote: "{count} руководств",
    browseGlossary: "Глоссарий",
    browseGlossaryNote: "{count} терминов",
    browseComparisons: "Сравнения стилей",
    browseComparisonsNote: "{count} сравнений",
    browseConverters: "Конвертеры",
    browseConvertersNote: "{count} конвертеров",
    browseCheatSheets: "Шпаргалки",
    browseCheatSheetsNote: "{count} шпаргалок",
    facetsLabel: "Фильтр по типу страницы",
    facetAll: "Все ({count})",
    noMatches: "Нет страниц, соответствующих запросу «{query}».",
    matchesOne: "{count} страница соответствует запросу «{query}».",
    matchesMany: "{count} страниц соответствуют запросу «{query}».",
    pagerLabel: "Страницы результатов",
    pagerPrevious: "← Назад",
    pagerNext: "Далее →",
    pagerPosition: "Страница {page} из {total}",
    paletteLoading: "Поиск…",
    paletteError: "Поиск сейчас недоступен. Попробуйте ещё раз.",
    paletteViewAll: "Показать все результаты по запросу «{query}»",
    apiNote:
      "Что-то создаёте? Тот же индекс доступен в формате JSON по адресу [/api/v1/search](/api/v1/search?q=podcast) и через MCP — см. [документацию для агентов](/ai).",
  },

  // /cite-this-page. The six FAQ answers used to exist twice — once in the layout for the
  // FAQPage markup and once in the page for the visible list — which is exactly the drift
  // this dictionary removes: both now read the same keys.
  citeThisPage: {
    metaTitle:
      "Процитировать эту страницу - ссылки в один клик (букмарклет и расширение Chrome)",
    metaDescription:
      "Процитируйте любую веб-страницу в один клик. Перетащите бесплатный букмарклет «Процитировать эту страницу» на панель закладок или установите бесплатное расширение Chrome с кнопкой на панели инструментов и оформлением ссылки через контекстное меню. Работает и на Chromebook, и в браузерах с ограничениями.",
    ogTitle: "Букмарклет и расширение Chrome «Процитировать эту страницу»",
    ogDescription:
      "Оформление ссылок на веб-сайты в один клик с любой страницы — букмарклет, который перетаскивается на панель закладок, плюс бесплатное расширение Chrome с оформлением ссылки через контекстное меню.",
    breadcrumbRoot: "CitationEasy",
    breadcrumbSchemaCurrent: "Букмарклет «Процитировать эту страницу»",
    appName: "Букмарклет «Процитировать эту страницу»",
    appDescription:
      "Бесплатный букмарклет, который в один клик оформляет ссылку на читаемую вами веб-страницу — он открывает CitationEasy с уже подставленным URL страницы и форматирует ссылку в стилях APA, MLA, Chicago и ещё {count} других.",
    breadcrumbLabel: "Цепочка навигации",
    breadcrumbHome: "Главная",
    breadcrumbCurrent: "Букмарклет «Процитировать эту страницу»",
    heading: "Процитировать эту страницу: букмарклет и расширение Chrome",
    intro:
      "Процитируйте любую веб-страницу в один клик — без регистрации. Перетащите букмарклет ниже на панель закладок (установка вообще не требуется) или установите бесплатное расширение Chrome с кнопкой на панели инструментов и оформлением через контекстное меню.",
    dragPrompt: "Перетащите эту кнопку на панель закладок:",
    buttonTitle: "Перетащите меня на панель закладок",
    buttonLabel: "📑 Процитировать эту страницу",
    dontClick:
      "Не нажимайте здесь — сначала перетащите кнопку на панель закладок.",
    installHeading: "Как установить",
    step1Title: "Покажите панель закладок",
    step1Body:
      "В большинстве браузеров нажмите Ctrl+Shift+B (Cmd+Shift+B на Mac), чтобы включить панель закладок и было куда перетащить кнопку.",
    step2Title: "Перетащите кнопку наверх",
    step2Body:
      "Нажмите и удерживайте кнопку «Процитировать эту страницу» ниже, затем перетащите её на панель закладок и отпустите. Она станет обычной закладкой.",
    step3Title: "Нажимайте её на любой странице",
    step3Body:
      "Читая статью, новость или страницу журнала, нажмите на новую закладку. CitationEasy откроется с уже подставленным URL страницы и готовой к копированию ссылкой.",
    manualHeading: "Не получается перетащить? Добавьте вручную",
    manualBody:
      "Создайте новую закладку, назовите её «Процитировать эту страницу» и вставьте это в качестве URL/адреса:",
    howHeading: "Как это работает",
    howBody:
      "Букмарклет не выполняет никакого кода на странице, которую вы читаете. Он лишь передаёт веб-адрес этой страницы в CitationEasy, где наш сервер загружает и разбирает открытые метаданные страницы — тот же надёжный путь, что используется, когда вы вставляете URL в генератор вручную. Это обеспечивает безопасность и позволяет избежать межсайтовых ограничений, из-за которых старые букмарклеты, работающие прямо на странице, перестали функционировать.",
    extensionHeading: "Предпочитаете расширение Chrome?",
    extensionBody:
      "Бесплатное расширение CitationEasy добавляет кнопку на панель инструментов, которая оформляет ссылку на текущую вкладку, а также пункты контекстного меню для оформления ссылки на ссылку — или на выделенный DOI либо ISBN — без её открытия. Как и букмарклет, оно не выполняет никакого кода на посещаемых страницах: оно лишь передаёт URL в CitationEasy. Ему нужны только разрешения `activeTab` и `contextMenus`, и оно работает в Chrome, Edge, Brave и других браузерах на основе Chromium.",
    downloadButton: "⬇ Скачать расширение Chrome (.zip)",
    install1: "Скачайте и распакуйте расширение.",
    install2:
      "Откройте `chrome://extensions` и включите **Режим разработчика** (в правом верхнем углу).",
    install3:
      "Нажмите **Загрузить распакованное расширение** и выберите распакованную папку.",
    install4:
      "Закрепите кнопку CitationEasy, затем нажимайте её на любой странице, чтобы процитировать её.",
    faqHeading: "Часто задаваемые вопросы",
    faqWhatQ: "Что такое букмарклет «Процитировать эту страницу»?",
    faqWhatA:
      "Это небольшая закладка, которую вы перетаскиваете на панель закладок браузера. Когда вы нажимаете её на любой веб-странице, она открывает CitationEasy в новой вкладке с уже подставленным URL страницы, так что вы получаете оформленную ссылку в один клик — без копирования и вставки.",
    faqExtensionNeededQ: "Нужно ли устанавливать расширение?",
    faqExtensionNeededA:
      "Нет. Букмарклет — это просто закладка, поэтому устанавливать нечего и разрешения предоставлять не нужно. Он работает на школьных Chromebook с ограничениями и в большинстве мобильных браузеров, где расширения заблокированы. Если вы предпочитаете расширение, на этой странице также доступно бесплатное расширение Chrome.",
    faqChromeQ: "Есть ли расширение для Chrome?",
    faqChromeA:
      "Да. Бесплатное расширение CitationEasy для Chrome добавляет кнопку на панель инструментов, которая оформляет ссылку на текущую вкладку, а также пункты контекстного меню для оформления ссылки или выделенного DOI/ISBN без её открытия. Оно не выполняет никакого кода на посещаемых страницах и требует только разрешений activeTab и contextMenus. Скачайте его с этой страницы и загрузите через chrome://extensions — оно работает в Chrome, Edge, Brave и других браузерах на основе Chromium.",
    faqAddQ: "Как добавить букмарклет?",
    faqAddA:
      "Убедитесь, что панель закладок видна, затем перетащите на неё кнопку «Процитировать эту страницу» с этой страницы. Если перетаскивание невозможно (например, на мобильном устройстве), создайте закладку вручную и вставьте код букмарклета в качестве URL.",
    faqSafeQ: "Это безопасно? Читает ли он страницу, на которой я нахожусь?",
    faqSafeA:
      "Да, это безопасно. Букмарклет не выполняет никакого кода на странице, которую вы читаете, — он лишь отправляет веб-адрес этой страницы в CitationEasy, где наш сервер загружает и разбирает открытые метаданные страницы точно так же, как при ручной вставке URL.",
    faqOtherSourcesQ: "Работает ли он для источников, кроме веб-сайтов?",
    faqOtherSourcesA:
      "Букмарклет предназначен для веб-страниц, но базовая ссылка также принимает DOI, ISBN, PMID или arXiv ID через параметр ?source= — так что ссылкой «процитировать это» можно поделиться и для журнальных статей, и для книг.",
    relatedHeading: "Похожие инструменты",
    relatedGenerator: "Генератор ссылок",
    relatedHowToCite: "Как процитировать веб-сайт",
    relatedTools: "Все инструменты",
  },

  // /shared-bibliography — opens a bibliography that travelled inside a share link.
  sharedBibliographyPage: {
    metaTitle: "Общий список литературы - просмотр и импорт ссылок",
    metaDescription:
      "Откройте список литературы, которым с вами поделились через CitationEasy. Просматривайте оформленные ссылки, копируйте их или импортируйте весь список в свою библиографию — бесплатно, без регистрации, а данные хранятся прямо в самой ссылке для доступа.",
    ogTitle: "Общий список литературы",
    ogDescription:
      "Просматривайте и импортируйте общий список литературы. Ссылки передаются внутри самой ссылки для доступа — ничего не хранится на сервере, и такие ссылки не истекают.",
    breadcrumbRoot: "CitationEasy",
    breadcrumbLabel: "Цепочка навигации",
    breadcrumbHome: "Главная",
    breadcrumbCurrent: "Общий список литературы",
    heading: "Общий список литературы",
    intro:
      "Кто-то поделился с вами этими ссылками. Скопируйте их или одним щелчком импортируйте весь список в свою библиографию CitationEasy.",
    loading: "Открываем общий список литературы…",
    copyAll: "Копировать все",
    copied: "Скопировано",
    copyFailed: "Не удалось скопировать",
    citationOne: "ссылка",
    citationMany: "ссылок",
    addAll: "Добавить всё в мою библиографию",
    added: "Добавлено в вашу библиографию: {count}",
    skippedOne: "Пропущен {count} дубликат",
    skippedMany: "Пропущено {count} дубликатов",
    openGenerator: "откройте генератор",
    emptyHeading: "В этой ссылке нет общего списка литературы",
    emptyBody:
      "На этой странице отображаются списки литературы, которыми поделились через CitationEasy. Чтобы поделиться своим, откройте библиографию в [генераторе ссылок](/), выберите **Экспорт → Копировать ссылку для доступа** и отправьте её кому угодно. Ссылки передаются внутри самой этой ссылки — ничего не хранится на сервере, поэтому такие ссылки работают вечно, а ваши данные остаются приватными.",
    decodeError: "Не удалось открыть эту ссылку для доступа.",
  },

  // The 19 source types the 15 detailed styles show worked examples for
  // (`DetailedStyleData.examples[].sourceType`). 75 rows, 19 distinct values — so this
  // is a vocabulary, not per-page copy, and it belongs here rather than repeated in
  // every locale's `src/content/style-pages/<locale>.json`.
  //
  // Two casings for the same reason `howToCitePage.refList*Lower` has two: the pages
  // print the label as a heading ("Book") and inside a sentence ("a sample APA entry
  // for a book"). Lower-casing the translated noun in code is wrong in German, where
  // every one of these is capitalised, so the lower form is a real key a translator
  // fills rather than a `.toLowerCase()` call.
  //
  // The citations themselves — `referenceEntry` and `inTextCitation` — are NOT here and
  // are not translatable anywhere: they are worked examples in a specific style's own
  // punctuation. See `src/lib/localized-content.ts`.
  sourceTypes: {
    book: "Книга",
    bookLower: "книга",
    bookChapter: "Глава книги",
    bookChapterLower: "глава книги",
    case: "Дело",
    caseLower: "дело",
    conferencePaper: "Доклад конференции",
    conferencePaperLower: "доклад конференции",
    courtCase: "Судебное дело",
    courtCaseLower: "судебное дело",
    federalStatute: "Федеральный закон",
    federalStatuteLower: "федеральный закон",
    governmentDocument: "Государственный документ",
    governmentDocumentLower: "государственный документ",
    governmentReport: "Государственный отчёт",
    governmentReportLower: "государственный отчёт",
    journalArticle: "Журнальная статья",
    journalArticleLower: "журнальная статья",
    lawReviewArticle: "Статья в юридическом журнале",
    lawReviewArticleLower: "статья в юридическом журнале",
    legislation: "Нормативный акт",
    legislationLower: "нормативный акт",
    newspaperArticle: "Статья в газете",
    newspaperArticleLower: "статья в газете",
    patent: "Патент",
    patentLower: "патент",
    podcast: "Подкаст",
    podcastLower: "подкаст",
    preprint: "Препринт",
    preprintLower: "препринт",
    standard: "Стандарт",
    standardLower: "стандарт",
    thesis: "Диссертация",
    thesisLower: "диссертация",
    website: "Веб-сайт",
    websiteLower: "веб-сайт",
    youtubeVideo: "Видео на YouTube",
    youtubeVideoLower: "видео на YouTube",
  },

  // Chrome shared by the five per-style guide routes — /examples, /format,
  // /in-text-citation, /reference-page and /annotated-bibliography, 15 styles each.
  //
  // One section rather than five copies: the CTA, the back link and the cross-links
  // between the five pages are the same sentences on every one of them, and duplicating
  // them per route would be five identical translation units instead of one.
  styleGuidePages: {
    backToStyle: "Назад к {style}",
    backToGenerator: "Назад к генератору ссылок",
    ctaHeading: "Создавайте ссылки {style} автоматически",
    ctaButton: "Оформить в {style} →",
    faqHeading: "Часто задаваемые вопросы",
    resourcesHeading: "Дополнительные материалы",
    relatedHeading: "Другие руководства по стилю {style}",
    resourceGenerator: "Бесплатный генератор ссылок ({count} стиля)",
    resourceTools: "Бесплатные инструменты для письма",
    resourceGuides: "Все руководства по оформлению",
    resourceStyleGenerator: "Генератор ссылок {style}",
    resourceExamples: "Примеры оформления {style}",
    resourceFormat: "Руководство по оформлению {style}",
    resourceInText: "Руководство по ссылкам в тексте {style}",
    resourceAnnotatedBib: "Руководство по аннотированной библиографии {style}",
    resourceReferencePage: "Руководство по {list} {style}",
    notFoundTitle: "Страница не найдена",
  },

  // /examples/<style> — the copy-ready worked examples for all 15 detailed styles.
  examplesPage: {
    metaTitle: "Примеры оформления {style} - все типы источников [2026]",
    metaDescription:
      "Смотрите оформленные примеры {style} ({edition}) для книг, журнальных статей, веб-сайтов и других источников. Готовые к копированию записи «{list}» и ссылки в тексте.",
    ogTitle: "Примеры оформления {style}",
    ogDescription:
      "Готовые к копированию записи {style} для всех распространённых типов источников.",
    ogImageTitle: "Примеры оформления {style}",
    ogKind: "{style} {edition}",
    keywordExamples: "примеры оформления {style}",
    keywordReference: "примеры списка литературы {style}",
    keywordInText: "примеры ссылок в тексте {style}",
    keywordList: "примеры {listLower} {style}",
    keywordHowTo: "как процитировать в стиле {style}",
    breadcrumb: "Примеры оформления {style}",
    heading: "Примеры оформления {style}",
    lead: "Смотрите правильно оформленные примеры {style} ({edition}) для {count} распространённых типов источников. Каждый пример включает и запись «{listLower}», и соответствующую ссылку в тексте.",
    entryLabel: "Запись «{list}»:",
    inTextLabel: "Ссылка в тексте:",
    ctaBody:
      "Не тратьте время на ручное оформление. Вставьте DOI, URL или ISBN в CitationEasy и получите безупречно оформленную ссылку {style} за считаные секунды.",
    faqLookQ: "Как выглядит ссылка {style}?",
    faqLookA:
      "Ссылка {style} включает запись «{listLower}» с полными сведениями об источнике и ссылку в тексте. Формат зависит от типа источника. Например, ссылка на книгу в стиле {style} ({edition}) включает автора, год, название и издательство.",
    faqHowManyQ: "Сколько примеров оформления {style} доступно?",
    faqHowManyA:
      "CitationEasy предоставляет примеры оформления {style} для {count} типов источников, включая {types}. Каждый пример включает и запись «{listLower}», и соответствующую ссылку в тексте.",
    faqCopyQ: "Можно ли скопировать эти примеры оформления {style}?",
    faqCopyA:
      "Да, примеры {style} на этой странице показывают точное оформление для каждого типа источника. Вы можете использовать их как шаблоны для своих ссылок. Для автоматического оформления используйте наш бесплатный генератор ссылок {style}.",
  },

  // /format/<style> — font, margins, spacing, title page and headers. The VALUES those
  // labels take are per-style prose and live in the overlay, not here.
  formatPage: {
    metaTitle:
      "Руководство по оформлению {style} - правила форматирования работы [2026]",
    metaDescription:
      "Полное руководство по оформлению работы в стиле {style} ({edition}). Узнайте правильный шрифт, поля, межстрочный интервал, титульный лист, колонтитулы и правила оформления «{listLower}».",
    ogTitle: "Оформление работы в стиле {style}",
    ogDescription:
      "Поля, шрифт, интервал и титульный лист для работы в стиле {style}.",
    ogImageTitle: "Оформление работы {style}",
    ogImageSubtitle: "поля {margins} · {spacing}",
    ogKind: "{style} {edition}",
    keywordFormat: "оформление {style}",
    keywordPaperFormat: "оформление работы {style}",
    keywordRules: "правила оформления {style}",
    keywordMargins: "поля шрифт интервал {style}",
    keywordList: "оформление {listLower} {style}",
    breadcrumb: "Руководство по оформлению {style}",
    heading: "Руководство по оформлению {style}",
    lead: "Следуйте этим правилам оформления работы {style} ({edition}), чтобы ваш документ соответствовал требованиям. Это руководство охватывает шрифт, поля, межстрочный интервал, титульный лист, колонтитулы и оформление «{listLower}».",
    paperHeading: "Оформление работы",
    paperIntro:
      "Ниже приведены основные требования к оформлению работ, написанных в стиле {style} ({edition}).",
    labelFont: "Шрифт",
    labelFontSize: "Размер шрифта",
    labelMargins: "Поля",
    labelSpacing: "Межстрочный интервал",
    labelTitlePage: "Титульный лист",
    labelHeaders: "Колонтитулы / номера страниц",
    listHeading: "Оформление «{list}»",
    listIntro:
      "Ваш «{listLower}» должен соответствовать этим правилам, чтобы быть правильно оформленным в стиле {style}:",
    ctaBody:
      "Доверьте оформление CitationEasy. Вставьте DOI, URL или ISBN и получите безупречно оформленную ссылку {style} за считаные секунды.",
    faqFontQ: "Какой шрифт и размер использовать для оформления {style}?",
    faqFontA:
      "{style} ({edition}) требует {font}. Стандартный размер шрифта — {fontSize}.",
    faqMarginsQ: "Какие требования к полям в стиле {style}?",
    faqMarginsA:
      "Для работ в стиле {style} требуются поля {margins}. Это касается верхнего, нижнего, левого и правого полей на каждой странице.",
    faqTitlePageQ: "Требуется ли титульный лист в стиле {style}?",
  },

  // /in-text-citation/<style> — the six in-text forms. The forms themselves
  // ("(Smith, 2024)") are per-style prose in the overlay.
  inTextCitationPage: {
    metaTitle:
      "Руководство по ссылкам в тексте {style} - правила и примеры [2026]",
    metaDescription:
      "Узнайте, как оформлять ссылки в тексте {style} ({edition}). Правила для одного автора, нескольких авторов, прямых цитат, отсутствующего автора и отсутствующей даты — с примерами.",
    ogTitle: "Ссылки в тексте {style}",
    ogDescription: "Все формы ссылок в тексте {style} с примерами.",
    ogImageTitle: "Ссылки в тексте {style}",
    ogImageSubtitle: "Один автор {singleAuthor} · три и более {threeOrMore}",
    ogKind: "{style} {edition}",
    keywordInText: "ссылка в тексте {style}",
    keywordExamples: "примеры ссылок в тексте {style}",
    keywordParenthetical: "ссылка в скобках {style}",
    keywordRules: "правила оформления ссылок {style}",
    keywordHowTo: "как оформить ссылку в тексте {style}",
    breadcrumb: "Ссылки в тексте {style}",
    heading: "Ссылки в тексте {style}",
    lead: "Освойте оформление ссылок в тексте {style} ({edition}) с помощью этого полного руководства. Узнайте правильный формат для каждой ситуации, включая одного и нескольких авторов, прямые цитаты и источники с отсутствующими сведениями.",
    rulesHeading: "Правила оформления ссылок в тексте",
    rulesIntro:
      "Ниже приведены правила оформления ссылок в тексте {style} для каждой распространённой ситуации, с которой вы столкнётесь при написании работы.",
    labelSingleAuthor: "Один автор",
    labelTwoAuthors: "Два автора",
    labelThreeOrMore: "Три и более авторов",
    labelDirectQuote: "Прямая цитата",
    labelNoAuthor: "Нет автора",
    labelNoDate: "Нет даты",
    examplesHeading: "Краткие примеры",
    examplesIntro:
      "Вот реальные примеры ссылок в тексте {style} для разных типов источников:",
    ctaBody:
      "Не переживайте об оформлении ссылок в тексте. Вставьте DOI, URL или ISBN в CitationEasy и мгновенно получите и запись «{listLower}», и ссылку в тексте.",
    faqFormatQ: "Как оформить ссылку в тексте {style}?",
    faqFormatA:
      "Для одного автора в стиле {style} используйте формат {singleAuthor}. Для двух авторов — {twoAuthors}. Для трёх и более авторов — {threeOrMore}.",
    faqQuoteQ: "Как процитировать прямую цитату в стиле {style}?",
    faqQuoteA:
      "Для прямых цитат в стиле {style} ({edition}) используйте формат: {directQuote}.",
    faqMissingQ: "Что делать, если в стиле {style} нет автора или даты?",
    faqMissingA:
      "Если автор не указан, в стиле {style} используйте: {noAuthor}. Если не указана дата, используйте: {noDate}.",
  },

  // /reference-page/<style> — how to build the list at the back of the paper.
  //
  // The five `mistake*` strings carry `**bold**` inline markup because the lead-in of
  // each bullet is emphasised inside the sentence; they render through `InlineText`.
  referenceListPage: {
    metaTitle: "Руководство по «{list}» {style} - правила оформления [2026]",
    metaDescription:
      "Узнайте, как оформить «{listLower}» {style} ({edition}). Пошаговые правила оформления, примеры и типичные ошибки, которых стоит избегать, для {fullName}.",
    ogTitle: "«{listLower}» {style}",
    ogDescription: "Как составить «{list}» в стиле {style}.",
    ogImageTitle: "«{list}» {style}",
    ogKind: "{style} {edition}",
    breadcrumb: "Как оформить «{list}» {style}",
    heading: "Как оформить «{list}» {style}",
    lead: "«{listLower}» — одна из самых важных частей любой академической работы, оформленной в стиле {style} ({edition}). Он даёт читателям полные сведения о каждом источнике, который вы процитировали, позволяя найти и проверить ваши ссылки. Правильное оформление важно для академической достоверности. Это руководство описывает точные правила, показывает реальные примеры и указывает на самые частые ошибки студентов.",
    rulesHeading: "Правила оформления",
    rulesIntro: "Следуйте этим правилам при составлении «{listLower}» {style}:",
    exampleHeading: "Пример «{list}»",
    exampleIntro:
      "Вот как выглядит «{listLower}» {style} с записями для разных типов источников:",
    mistakesHeading: "Типичные ошибки, которых стоит избегать",
    mistakesIntro:
      "Вот пять самых частых ошибок оформления, которые студенты допускают при составлении «{listLower}» {style}:",
    mistakeIndent:
      "**Отсутствующий или неверный висячий отступ:** первая строка каждой записи должна начинаться от левого края, а все последующие строки — с отступом 1,27 см (0,5 дюйма). Используйте настройки абзаца в текстовом редакторе, а не клавишу Tab.",
    mistakeOrder:
      "**Неверный алфавитный порядок:** записи должны располагаться согласно правилам {style}. При алфавитной сортировке не учитывайте артикли вроде «A», «An» и «The». Для числовых стилей перечисляйте записи в порядке их первого упоминания в тексте.",
    mistakeSpacing:
      "**Непоследовательный интервал:** проверьте межстрочный интервал по всему «{listLower}». Смешение одинарного и двойного интервала — частая ошибка, которую легко упустить.",
    mistakeItalics:
      "**Неверное использование курсива:** выделяйте курсивом названия самостоятельных изданий — книг и журналов, — но не выделяйте курсивом названия статей или глав. Уточните в правилах {style}, какие именно элементы должны быть курсивными.",
    mistakeLinks:
      "**Отсутствующие или неработающие DOI и URL:** всегда указывайте DOI, если он доступен, оформленный как кликабельная ссылка. Проверьте каждый URL перед сдачей работы, чтобы убедиться, что он ведёт на нужный источник.",
    ctaHeading: "Создайте «{list}» автоматически",
    ctaBody:
      "Не тратьте время на ручное оформление. Вставьте DOI, URL или ISBN в CitationEasy и получите безупречно оформленную ссылку {style} за считаные секунды — готовую для вашего «{listLower}».",
    faqWhatQ: "Что такое «{list}» {style}?",
    faqWhatA:
      "«{list}» {style} — это раздел в конце работы, где перечислены все источники, процитированные в тексте, оформленные согласно правилам {fullName} ({edition}). Он позволяет читателям найти и проверить каждый источник, на который вы ссылались.",
    faqFormatQ: "Как оформить «{listLower}» {style}?",
    faqFormatA:
      "Начните с новой страницы, озаглавьте её «{list}» и перечислите все источники, процитированные в работе. Следуйте конкретным правилам {style} для висячих отступов, интервала, алфавитного или числового порядка и курсива.",
    faqDifferenceQ: "В чём разница между «{listLower}» и библиографией?",
    faqDifferenceA:
      "«{listLower}» включает только источники, которые вы непосредственно процитировали в работе, тогда как библиография может включать и источники, которые вы изучали, но не цитировали. В стиле {style} ({edition}) список в конце работы называется «{list}».",
  },

  // /annotated-bibliography/<style>. `whatTypes` carries `**bold**` inline markup.
  //
  // `exampleAnnotation` is a specimen annotation, not a citation: it is ordinary prose
  // about an imaginary source and translates like any other paragraph. The reference
  // entry printed above it does not — that comes from `DETAILED_STYLES` and stays as
  // the style wrote it.
  annotatedBibPage: {
    metaTitle:
      "Руководство и примеры аннотированной библиографии {style} [2026]",
    metaDescription:
      "Узнайте, как составить аннотированную библиографию в стиле {style} ({edition}). Включает правила оформления, примеры записей и советы для аннотированных библиографий {fullName}.",
    ogTitle: "Аннотированная библиография {style}",
    ogDescription: "Как оформить аннотированную библиографию в стиле {style}.",
    ogImageTitle: "Аннотированная библиография {style}",
    ogKind: "{style} {edition}",
    breadcrumb: "Аннотированная библиография {style}",
    heading: "Аннотированная библиография {style}",
    lead: "Аннотированная библиография — это список ссылок на источники, каждая из которых сопровождается коротким описательным или оценочным абзацем. В формате {style} ({edition}) каждая запись начинается с правильно оформленной ссылки, за которой следует аннотация, кратко излагающая содержание источника, оценивающая его или отражающая ваше мнение о нём. Это руководство проведёт вас через правила, оформление и примеры, необходимые для составления безупречной аннотированной библиографии {style}.",
    whatHeading: "Что такое аннотированная библиография?",
    whatBody:
      "Аннотированная библиография отличается от обычного «{listLower}» тем, что после каждой ссылки добавляется короткий абзац. Эта аннотация даёт читателям представление о содержании, качестве и значимости источника. Преподаватели часто задают аннотированные библиографии, чтобы помочь студентам критически оценивать источники и показать, как каждый источник связан с темой исследования.",
    whatTypes:
      "Есть три распространённых типа аннотаций: **описательные** аннотации, которые кратко излагают содержание источника, **оценочные** аннотации, которые оценивают качество и достоверность работы, и **комбинированные** аннотации, сочетающие оба подхода. Указания к заданию должны определять, какой тип использовать.",
    rulesHeading: "Правила аннотированной библиографии {style}",
    rulesIntro:
      "Следуйте этим правилам при оформлении аннотированной библиографии в {fullName}:",
    exampleHeading: "Пример записи аннотированной библиографии",
    exampleIntro:
      "Ниже приведён образец записи аннотированной библиографии {style} для источника типа «{sourceType}»:",
    exampleAnnotation:
      "Этот источник даёт всесторонний обзор темы, представляя хорошо обоснованные аргументы, подкреплённые эмпирическими данными. Автор опирается на широкий круг первичных и вторичных источников, выстраивая убедительную аргументацию. Методология строгая, а результаты изложены ясно, что делает эту работу ценным ресурсом для понимания темы. Этот источник особенно полезен для формирования теоретической базы исследовательского проекта и предлагает точки зрения, дополняющие другие работы в библиографии.",
    tipsHeading: "Советы по написанию аннотаций {style}",
    tipSummarize:
      "Начните с краткого изложения источника в двух-трёх предложениях, затем добавьте оценку его сильных сторон, ограничений и значимости.",
    tipTone:
      "Используйте третье лицо и академический тон на протяжении всей аннотации. Избегайте разговорного языка или рассуждений от первого лица, если только преподаватель этого не просит.",
    tipLength:
      "Каждая аннотация должна содержать от 100 до 200 слов. Будьте лаконичны и сосредоточьтесь на самых важных аспектах источника.",
    tipRelevance:
      "Объясните, как источник вписывается в ваше общее исследование. Опишите, какую уникальную точку зрения или доказательства он привносит.",
    tipCitation:
      "Прежде чем писать аннотацию, убедитесь, что ссылочная часть каждой записи точно соответствует правилам оформления {fullName}.",
    ctaHeading: "Составьте аннотированную библиографию автоматически",
    ctaBody:
      "Используйте конструктор аннотированной библиографии CitationEasy, чтобы создать правильно оформленные ссылки {style}, а затем добавьте свои аннотации.",
    ctaButton: "Открыть конструктор аннотированной библиографии →",
    faqWhatQ: "Что такое аннотированная библиография в стиле {style}?",
    faqWhatA:
      "Аннотированная библиография в стиле {style} ({edition}) — это список ссылок, оформленных в стиле {fullName}, каждая из которых сопровождается коротким абзацем, кратко излагающим, оценивающим или отражающим содержание источника. Она помогает читателям понять значимость и качество каждого источника.",
    faqLengthQ: "Какой длины должны быть аннотации?",
    faqLengthA:
      "Аннотации обычно занимают от 100 до 200 слов. Некоторые задания могут требовать более коротких или длинных аннотаций в зависимости от требуемой глубины анализа. Всегда сверяйтесь с указаниями преподавателя по конкретным требованиям к длине.",
    faqIncludeQ: "Что должна включать аннотация?",
    faqIncludeA:
      "Аннотация должна включать краткое изложение основного аргумента или выводов источника, оценку его достоверности и полезности, а также размышление о том, как источник связан с вашим исследованием. Некоторые аннотации носят чисто описательный характер, другие включают критический анализ.",
  },

  guidePage: {
    byline: "Автор: {author}",
    published: "Опубликовано: {date}",
    updated: "Обновлено: {date}",
    readingTime:
      "one:{count} минута чтения|few:{count} минуты чтения|many:{count} минут чтения|other:{count} минуты чтения",
    wordCount:
      "one:{count} слово|few:{count} слова|many:{count} слов|other:{count} слова",
  },

  // /guides hub, /guides/<category> index pages, and the chrome around each guide
  guideLibrary: {
    eyebrow: "Библиотека руководств",
    browseByCategory: "Просмотр по категориям",
    recentlyUpdated: "Недавно обновлённые",
    allGuides: "Все руководства",
    guideCount:
      "one:{count} руководство|few:{count} руководства|many:{count} руководств|other:{count} руководства",
    updatedOn: "Обновлено {date}",
    minRead:
      "one:{count} мин чтения|few:{count} мин чтения|many:{count} мин чтения|other:{count} мин чтения",
    onThisPage: "На этой странице",
    viewAllInCategory: "Все руководства: {category}",
    moreInCategory: "Ещё в разделе «{category}»",
    aboutThisGuide: "Об этом руководстве",
    provenance:
      "Автор: {author}. Опубликовано {published}; последнее обновление {updated}.",
    categoryIntroSuffix:
      "Каждое руководство бесплатно, написано для студентов и исследователей и датировано, чтобы вы видели, когда его проверяли в последний раз.",
    photoCredit: "Фото: {author}, {source} ({license})",
    imageAlt: "Фотография к руководствам раздела «{category}»",
    imageSourceCommons: "Викисклад",
    apaStyleName: "Стиль APA",
    apaStyleDescription:
      "Как цитировать сайты, журнальные статьи, книги, видео и другое по APA 7-го издания — с примерами списка литературы и внутритекстовых ссылок.",
    mlaStyleName: "Стиль MLA",
    mlaStyleDescription:
      "Как цитировать любые распространённые источники по MLA 9-го издания: от веб-страниц и статей до стихов, пьес, фильмов и учебных материалов.",
    chicagoStyleName: "Стиль Chicago",
    chicagoStyleDescription:
      "Руководства по Chicago Manual of Style: сноски с библиографией и система автор-дата для книг, статей, архивов, официальных документов и медиа.",
    styleComparisonsName: "Сравнение стилей",
    styleComparisonsDescription:
      "Сравнение APA, MLA, Chicago, Harvard, Vancouver, IEEE и других бок о бок, а также советы, какой стиль ожидает ваша дисциплина.",
    researchMethodsName: "Методы исследования",
    researchMethodsDescription:
      "Как спланировать исследовательскую работу, сделать обзор литературы, вести заметки, оценивать источники, избегать плагиата и составить библиографию.",
    academicWritingName: "Академическое письмо",
    academicWritingDescription:
      "Руководства по написанию аннотаций, введений, заключений, тезисов, разделов о методологии и ясной научной прозы.",
    fieldSpecificName: "По дисциплинам",
    fieldSpecificDescription:
      "Руководства по цитированию для отдельных дисциплин — от психологии, истории и литературы до медицины, инженерии, права и сестринского дела.",
    sourceEvaluationName: "Оценка источников",
    sourceEvaluationDescription:
      "Как оценивать достоверность, отличать научные источники от популярных, пользоваться Google Scholar и библиотечными базами и замечать предвзятость.",
    citationHelpName: "Помощь с цитированием",
    citationHelpDescription:
      "Ответы на сложные случаи: нет автора или даты, несколько авторов, PDF, инструменты ИИ, судебные дела, импорт и экспорт ссылок.",
  },

  common: {
    backToGuides: "← Вернуться к руководствам",
    free: "Бесплатно",
    noSignup: "Без регистрации",
    backToHome: "Вернуться к генератору ссылок",
    inEnglish: "На английском",
    viewInEnglish: "Открыть на английском",
    availableInEnglish:
      "Эта страница доступна на английском языке в более подробной версии.",
    otherLanguages: "Другие языки",
    skipToContent: "Перейти к содержимому",
    cookieNotice:
      "Мы используем файлы cookie для аналитики и рекламы, чтобы CitationEasy оставался бесплатным.",
    privacyPolicy: "Политика конфиденциальности",
    accept: "Принять",
    decline: "Отклонить",
    advertisement: "Реклама",
  },
  legalPage: {
    backLink: "← Назад к генератору",
    effective: "Дата вступления в силу:",
    updated: "Последнее обновление:",
  },
};

export default ru;
